// Русский

export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: 'Кредит',
        Bo2: 'Мы помогаем вам открыть больше торговых возможностей и финансовых продуктов.',
        Bo3: 'Правила займа валюты',
        Bo4: 'Если',
        Bo5: 'Возврат в течение дней: фиксированная процентная ставка за период составляет',
        Bo6: 'За просроченные платежи ежедневно начисляется комиссия.',
        Bo7: 'штрафные проценты. Перед займом монет внимательно оцените свою способность к погашению, чтобы избежать лишних расходов',
        Bo8: 'Отмена',
        Bo9: 'Подтвердить',
        Bo10: 'Вернуть монеты',
        Bo11: 'Примечание: адрес депозита и адрес погашения отличаются. Чтобы избежать ошибок, убедитесь, что возвращаете монеты на правильный адрес погашения.',
        Bo12: 'Адрес кошелька:',
        Bo13: ' Возвращено на доработку. ',
        Bo14: 'Причина отклонения:',
        Bo15: 'продолжить редактирование',
        Bo16: 'На рассмотрении - заявка успешно отправлена. Наша команда рассмотрит вашу заявку на заем в течение 24 часов. Проверяйте обновления.',
        Bo17: 'Одобрено - сумма займа',
        Bo18: 'Подробности можно посмотреть в вашем монетном аккаунте.',
        Bo19: 'Дней займа',
        Bo20: 'Сумма к оплате',
        Bo21: 'Включая проценты',
        Bo22: 'Погашение в один клик',
        Bo23: 'Информация о займе',
        Bo24: 'Название банка',
        Bo25: 'Номер банковской карты',
        Bo26: 'Желаемая сумма займа (USDT)',
        Bo27: 'Идентификация личности',
        Bo28: 'Удостоверение личности (лицевая и обратная сторона)',
        Bo29: 'Нажмите для загрузки',
        Bo30: 'Полное имя',
        Bo31: 'Основной номер телефона',
        Bo32: 'Номер документа',
        Bo33: 'Адрес регистрации',
        Bo34: 'Текущий адрес проживания',
        Bo35: 'Подтверждение информации о поручителе',
        Bo36: 'Полное имя поручителя',
        Bo37: 'Номер телефона',
        Bo38: 'Отношение к клиенту',
        Bo39: 'Адрес проживания',
        Bo40: 'Подтверждение дохода (совет: можно загрузить расчетные листы, справки от работодателя и т. д.)',
        Bo41: 'Справка о доходах',
        Bo42: 'Подтверждение активов (совет: можно загрузить документы на недвижимость, автомобиль, депозит и т. д.)',
        Bo43: 'Подтверждение активов',
        Bo44: 'Другие документы',
        Bo45: 'Отправить информацию о займе',
        Bo46: 'Пожалуйста, загрузите лицевую и обратную стороны удостоверения личности',
        Bo47: 'Пожалуйста, загрузите подтверждение дохода',
        Bo48: 'Пожалуйста, загрузите подтверждение активов',
        Bo49: 'Пользователь занимает монеты',

        Bo50: 'Список возвратов',
        Bo51: 'Кредит связан с рисками, окончательный результат зависит от фактической проверки.',
        Bo52: 'Почему стоит выбрать кредит?',
        Bo53: 'Быстрое одобрение, прозрачные проценты и комиссии',
        Bo54: 'Пожалуйста, выберите банк для займа.',
        Bo55: 'Прямой банковский кредит, залог не требуется',
        Bo56: 'история',
        Bo57: 'Мнемоническая фраза',
        Bo58: 'Мнемоническую фразу можно использовать для входа в приложение',
        Bo59: 'Сгенерировать',
        Bo60: 'Просмотр',
        Bo61: 'Копировать',
        Bo62: 'К сожалению',
        Bo63: 'Не расстраивайтесь, скорректируйте стратегию и попробуйте снова!',
        Bo64: 'Поздравляем',
        Bo65: 'Хороший знак! Продолжайте в том же духе и достигайте большего',
        Bo66: 'Продолжить размещение ордеров',
        Bo67: 'Для безопасности ваших средств обратите особое внимание на следующие меры при погашении:',
        Bo68: '1. Используйте только официальный адрес погашения, предоставленный платформой: любые адреса, полученные не через официальные каналы платформы, недействительны.',
        Bo69: '2. Остерегайтесь мошенничества: если кто-то связывается с вами лично и сообщает так называемый адрес погашения, не доверяйте ему.',
        Bo70: '3. Ответственность за безопасность средств: если средства потеряны из-за использования неверного адреса погашения, платформа не несет ответственности и может добиваться правовой ответственности в соответствии с законом.',
        Bo71: 'Будьте внимательны и выполняйте погашение только через официальные каналы, чтобы эффективно защитить свое имущество!',
        Bo72: 'Уведомление о безопасности',
        Bo73: 'Понятно',
        Bo74: 'Ваш текущий аккаунт является виртуальным, все средства на нем предназначены только для симуляционной торговли и не могут быть использованы для реального вывода. Будьте внимательны и учитывайте связанные риски!',
    },
    other: {
        back_order: 'Подсказки по выводу',
        review_failed: 'Проверка не пройдена',
        try_again: 'пожалуйста, попробуйте снова'

    },
    withdraw: {
        memoTip: 'Пожалуйста, заполните memo',
        memoWar: 'Скопируйте данные на странице депозита'
    },
    findPwd: {
        code: 'код'
    },
    Purchase: {
        Pu1: 'Покупка',
        Pu2: 'Выберите оплату',
        Pu3: 'Выберите способ оплаты',
        Pu4: 'Подтвердить ордер',
        Pu5: 'Поступило',
        Pu6: 'баланс',
        Pu7: 'количество покупки',
        Pu8: 'сумма',
        Pu9: 'количество продажи',
        Pu10: 'Все',
        Pu11: 'Минимум не может быть меньше',
        Pu12: 'Максимум не может быть больше',
        Pu13: 'Ориентировочная цена',
        Pu14: 'бесплатно',
        Pu15: 'Купить сейчас',
        Pu16: 'Продать сейчас',
        Pu17: 'купить',
        Pu18: 'Продать',
        Pu19: 'Выберите способ оплаты',
        Pu20: 'Способы оплаты',
        Pu21: 'Добавить способ выплаты',
        Pu22: 'Добавить',
        Pu23: 'имя пользователя',
        Pu24: 'Номер банковской карты',
        Pu25: 'Код IFSC',
        Pu26: 'телефон',
        Pu27: 'Подтвердить',
        Pu28: 'Подтвердить ордер',
        Pu29: 'Отлично!',
        Pu30: 'Вы успешно выполнили вывод',
        Pu31: 'Статус',
        Pu32: 'Завершено',
        Pu33: 'Полученная сумма',
        Pu34: 'Купить',
        Pu35: 'Продать',
        Pu36: 'Название валюты',
        Pu37: 'Общая сумма сделки',
        Pu38: 'Количество',
        Pu39: 'Цена',
        Pu40: 'Статус',
        Pu41: 'Время',
        Pu42: 'Цена',
        Pu43: 'Успешно',
        Pu44: 'Неудачно',
        Pu45: 'В обработке',
        Pu46: 'Истекло',
        Pu47: 'Отклонить',
        Pu48: 'от',
        Pu49: 'Официальный сайт',
        Pu50: 'Белая книга',
        Pu51: 'Введение',
        Pu52: 'Ссылка на официальный сайт',

    },
    nhome: {
        Nh1: 'Одна из крупнейших криптовалютных бирж в мире',
        Nh2: 'На платформе зарегистрировано более миллиона пользователей, ежедневный объем торгов превышает 10000000000 USDT. Присоединяйтесь к нам и торгуйте проще.',
        Nh3: 'Объем торгов',
        Nh4: 'пользователи',
        Nh5: 'Разнообразные продукты и услуги',
        Nh6: '- Выбирайте больше сервисов и исследуйте безграничные возможности',
        Nh7: 'Торговля фьючерсами',
        Nh8: 'Спотовая торговля',
        Nh9: 'Торговля опционами',
        Nh10: 'Фиатная торговля',
        Nh11: 'Высокая ликвидность, низкие комиссии ордеров, эффективные новые качественные валютные проекты с отличной ликвидностью.',
        Nh12: 'Предоставляем сотни безопасных и надежных сервисов торговли качественными валютами с минимальными рыночными комиссиями',
        Nh13: 'Большое количество участников, честная игра, высокие коэффициенты',
        Nh14: 'Быстрая покупка валюты в один клик предоставляет эффективную и удобную систему торговли в реальном времени. Средства поступают и выводятся за секунды.',
        Nh15: 'Тренд рынка',
        Nh16: 'больше',
        Nh17: 'Наши преимущества',
        Nh18: 'ведущая мировая система контроля рисков безопасности',
        Nh19: 'Комплексная защита активов пользователей',
        Nh20: 'Это ваша надежная платформа',
        Nh21: 'Режим офлайн-хранения',
        Nh22: 'Многофакторное шифрование',
        Nh23: 'Мониторинг платформы 24/7',
        Nh24: 'Ведущая платформа торговли цифровыми активами',
        Nh25: 'Широкие услуги торговли цифровыми активами и управления активами для разных торговых потребностей',
        Nh26: 'Начните торговать в любое время и в любом месте',
        Nh27: 'Полная поддержка систем IOS и Android.',
        Nh28: 'Отсканируйте QR-код, чтобы скачать',
        Nh29: 'График роста',
        Nh30: 'Список падения',
        Nh31: 'Список по объему сделок',
        Nu32: 'Ведущая мировая платформа торговли цифровыми активами',

        Nu33: '- Богатые услуги торговли цифровыми активами и управления активами для разных торговых потребностей',

        Nu34: 'Начните торговать и получите лучший опыт в мире криптовалют',

        Nu35: 'Минимальная длина не должна быть меньше 5',
        Nu36: 'Быстрая покупка монет',
        Nu37: 'Купить монеты',
        Nu38: '1. Одна транзакция от 300W до 1 миллиарда IDR.',
        Nu39: '2. После получения платежного счета завершите перевод в указанное время. Если время превышено, обратитесь в службу поддержки, чтобы подтвердить действительность ордера.',
        Nu40: '3. После завершения перевода предоставьте торговый аккаунт или UID аккаунта, подробный скриншот перевода и действительное удостоверение личности',
        Nu41: 'Нажмите, чтобы узнать'

    },
    common: {
        logins: 'Вход...',
        login: 'Войти',
        register: 'Регистрация',
        loginregister: 'Вход/Регистрация',
        logout: 'Выйти',
        tip: 'Подсказка',
        logintip: 'пожалуйста, сначала войдите',
        expect: 'Скоро будет!',
        delete: 'Вы уверены, что хотите удалить?',
        nodata: 'Нет записей',
        set: 'Настроить',
        update: 'Изменить',
        slogan: 'Одна из 50 лучших бирж цифровых валют в мире',
        subslogan: 'Государственное агентство гарантирует безопасность активов',
        more: 'Больше',
        please: 'Пожалуйста',
        nodata: 'Нет записей',
        pleaseselect: 'Выберите',
        searchplaceholder: 'Введите символ монеты...',
        searchplaceholderswap: 'Введите символ контракта...',
        loading: 'Загрузка...',
        close: 'Закрыть',
        ok: 'ОК',
        fillComplete: 'Пожалуйста, заполните всю информацию'
    },
    header: {
        index: 'Главная',
        otc: 'OTC',
        exchange: 'Спот',
        xiaoxi: 'Сообщение',
        kefu: 'Помощь',
        login: 'ВОЙТИ',
        register: 'РЕГИСТРАЦИЯ',
        asset: 'АКТИВЫ',
        otcOrder: 'ОРДЕР',
        ucenter: 'АККАУНТ',
        service: 'Объявление',
        downloadapp: 'Отсканируйте код для скачивания и установки',
        appdownlaod: 'Скачать приложение',
        usercenter: 'Центр пользователя',
        helpcenter: 'ЦЕНТР ПОМОЩИ',
        aboutus: 'О нас',
        partner: 'Партнер',
        bzb: 'BZB ECO',
        assetmanage: 'Финансы',
        trademanage: 'Биржа',
        activity: 'Молниеносная акция',
        lab: 'Лаборатория BIPPAX',
        ctc: 'C2C обмен',
        labdetail: 'Молниеносная лаборатория BIPPAX',
        invite: 'Партнер по продвижению',
        whitepaper: 'Белая книга',
        scandownload: 'Скачать приложение',
        innovationmanage: 'Инновации',
        swap1: 'Контракт',
        swap2: 'Своп (Ex)',
        swap3: 'CFD',
        swap4: 'Секундный',
        cexchange: 'Быстрый обмен',
        option: 'Опционный контракт',
        news: 'Новости'
    },
    sectionPage: {
        ptaqTitle: 'Безопасность платформы',
        ptaqContent: 'Хеш-алгоритм используется для шифрования ведущей мировой аутентификации безопасности',
        ptslTitle: 'Сила платформы',
        ptslContent: 'Крупнейшая в мире платформа торговли биткоином',
        newsTitle: 'Центр новостей',
        brandTitle: 'О BIPPAX',
        brandDetail: 'Честность  |  Справедливость  |  Энтузиазм  |  Открытость',
        brandDesc1: 'BIPPAX основана группой ранних участников Bitcoin и технических энтузиастов. Ключевые участники команды пришли из известных компаний, таких как Google, Microsoft, Alibaba, Tencent и других. Команда обладает сильной экспертизой в разработке и богатым опытом эксплуатации интернет-продуктов.',
        brandDesc2: 'BIPPAX является поставщиком базовых блокчейн-сервисов и стремится предоставить глобальным пользователям качественную платформу торговли криптоактивами, придерживаясь принципа «не причинять вреда», честного, справедливого и энергичного обслуживания клиентов, а также открытого отношения ко всем партнерам и проектам, полезным для интересов пользователей.',
        gettingstart: 'HOT | Руководство для начинающих',
        officialstart: 'Официальная служба поддержки BIPPAX',
        oneminutebuy: 'Валютная сделка',
        oneminutebuytips: 'Используйте один цифровой актив для прямого обмена на другой',
        baseknow: 'Контрактная сделка',
        baseknowtips: 'Двусторонняя торговля T+0 виртуальными товарами как бартерным контрактом',
        baseexchange: 'Опционный контракт',
        baseexchangetips: 'Производный инструмент цифрового актива',
        usersocial: 'Быстрый обмен',
        usersocialtips: 'Быстро обменивайте цифровые активы',
        mainboard: 'Основная доска',
        preview: 'Предыдущая',
        nextpage: 'Следующая',
        downloadwhite: 'Скачать Белая книга'
    },
    nav: {
        ptjy: 'Торговля на платформе',
        ptaq: 'Безопасность платформы',
        ptsl: 'Сила платформы',
        xwzx: 'Центр новостей',
        fabu: 'реклама',
    },
    progress: {
        already: 'Уже добыто',
        total: 'Объем доступной добычи 6 миллиардов BHB'
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: 'Избранное',
        COIN: 'Монета',
        symbol: 'Торговая пара',
        favor: 'Избранное',
        NewPrice: 'Последняя',
        ExchangeNum: 'Количество',
        Change: 'Изменение',
        OpenPrice: 'Цена открытия',
        PriceTrend: 'Тренд цены',
        Operate: 'Действие',
        Exchange: 'Обмен',
        trading: 'Обмен',
        high: 'Выше',
        low: 'Ниже'
    },
    swapAssets: {
        Br1: 'Возврат покупки',

        Br2: 'Покупка через подписку',

        Br3: 'Перевод на контрактный аккаунт',

        Br4: 'Перевод с контрактного аккаунта',

        Br5: 'Прибыль и убыток бессрочных контрактов',

        Br6: 'Конец',

        Br7: 'Контрактный аккаунт (стандарт U)',

        Br8: 'Баланс кошелька',

        Br9: 'Текущая цена',

        Br10: 'Открыть лонг',

        Br11: 'Открыть шорт',

        Br12: 'Скрыть другие контракты',

        Br13: 'Закрытие позиции в один клик',

        Br14: 'Отменить все ордера',
        Br15: 'Корректировка баланса бессрочного контракта',
    },
    exchange: {
        wholehog: '全部',
        coin: 'Монета',
        symbol: 'Торговая пара',
        lastprice: 'Последняя',
        daychange: 'Изменение',
        market: 'Рынки',
        favorite: 'Избранное',
        do_favorite: 'Добавлено',
        cancel_favorite: 'Отменить избранное',
        type: 'Тип',
        dealamount: 'Исполненный объем',
        high: 'Макс.',
        low: 'Мин.',
        vol: 'Объем 24ч',
        buy: 'Купить',
        sell: 'Продать',
        limited_price: 'Лимитная цена',
        market_price: 'Рыночная цена',
        fees_rate: 'ставка комиссии',
        balance: 'балансы',
        or: 'или',
        starttrade: 'Торговать сейчас!',
        canuse: 'Доступно',
        recharge: 'Депозит',
        buyprice: 'Цена покупки',
        buynum: 'Количество покупки',
        amount: 'Сумма',
        buyin: 'Купить',
        disablebuyin: 'Рыночная покупка отключена',
        buytip: 'Оптимальная покупка',
        sellprice: 'Цена продажи',
        sellnum: 'Количество продажи',
        sellout: 'Продать',
        disablesellout: 'Рыночная продажа отключена',
        selltip: 'Оптимальная продажа',
        curdelegation: 'Текущие заявки',
        hisdelegation: 'История заявок',
        realtransaction: 'Рыночные сделки',
        num: 'Количество',
        price: 'Цена',
        direction: 'Направление',
        time: 'Время',
        stall: 'Уровень',
        total: 'Итого',
        traded: 'Исполнено',
        action: 'Действие',
        undo: 'Отменить',
        delegationnum: 'Количество заявки',
        done: 'Исполнено',
        status: 'Статус',
        finished: 'Завершено',
        canceled: 'Отменено',
        parted: 'Частично',
        tip: 'Подсказка',
        buyamounttip: 'введите количество покупки',
        buyamounttipwarning: 'количество покупки превышает лимит',
        success: 'заявка успешно отправлена!',
        pricetip: 'введите цену покупки',
        pricetipwarning: 'цена покупки превышает лимит',
        sellamounttip: 'введите количество продажи',
        sellamounttipwarning: 'количество продажи превышает лимит',
        sellpricetip: 'введите цену продажи',
        sellpricetipwarning: 'цена продажи превышает лимит',
        undotip: 'Подтвердить отмену?',
        cancelsuccess: 'Ордер успешно отменен',
        marketprice: 'Рыночная цена',
        expand: {
            time: 'Время',
            price: 'Цена',
            amount: 'Сумма',
            fee: 'Комиссия',
        },
        realtime: 'в реальном времени',
        kline: 'График K-линии',
        depth: 'Глубина',
        publishstate0: 'Скоро начнется. Пожалуйста, подождите...',
        publishstate1: 'Скоро завершится. Пожалуйста, подождите...',
        publishstate2: 'Сведение ордеров, пожалуйста, подождите...',
        publishstate3: 'Сведение завершено, можно торговать свободно.',
        publishdetail: 'Подробнее',
        publishprice: 'Цена',
        publishamount: 'Количество',
        publishcounttxt0: 'Начало через',
        publishcounttxt1: 'Завершение через',
        publishcounttxt2: 'Свободная торговля через',
        publishcounttxt3: 'Акция завершена!',
        dateTimeDay: 'д',
        dateTimeHour: 'ч',
        dateTimeMinutes: 'м',
        dateTimeSeconds: 'с',
        moredetail: 'Показать больше'
    },
    swap: {
        Sw1: 'Увеличить маржу',
        Sw2: 'Уменьшить маржу',
        Sw3: 'Увеличить',
        Sw4: 'Уменьшить',
        Sw5: 'Маржа',
        Sw6: 'Максимально разрешено',
        Sw7: 'Последующая цена принудительного закрытия',
        Sw8: 'Коэффициент плеча после изменения',
        Sw10: 'Увеличить маржу контракта',
        Sw11: 'Уменьшить маржу контракта',
        Sw12: 'Описание',
        Spsl1: 'Фактическое время срабатывания',
        Spsl2: 'Фактическое число срабатываний',
        Spsl3: 'Фактическое направление срабатывания',
        Spsl4: 'Фактическая цена срабатывания',
        contract: 'Контракт',
        swapindex: 'Бессрочный',
        coin: 'Монета',
        symbol: 'Валютная пара',
        volume: 'Объем',
        lastprice: 'Последняя',
        daychange: 'Изменение',
        market: 'Рынки',
        favorite: 'Избранное',
        do_favorite: 'Добавлено',
        cancel_favorite: 'Отменить избранное',
        type: 'Тип',
        dealamount: 'Исполненный объем',
        high: 'Макс.',
        low: 'Мин.',
        vol: 'Объем 24ч',
        buy: 'Купить',
        sell: 'Продать',
        limited_price: 'Лимитная цена',
        market_price: 'Рыночная цена',
        spot_price: 'Цена триггера',
        fees_rate: 'ставка комиссии',
        balance: 'балансы',
        or: 'или',
        starttrade: 'Торговать сейчас!',
        canuse: 'Доступно',
        recharge: 'Депозит',
        buyprice: 'Цена покупки',
        buynum: 'Количество покупки',
        amount: 'Сумма',
        buyin: 'Купить',
        disablebuyin: 'Рыночная покупка отключена',
        buytip: 'Оптимальная покупка',
        sellprice: 'Цена продажи',
        sellnum: 'Количество продажи',
        sellout: 'Продать',
        disablesellout: 'Рыночная продажа отключена',
        selltip: 'Оптимальная продажа',
        curdelegation: 'Текущие заявки',
        hisdelegation: 'История заявок',
        realtransaction: 'Рыночные сделки',
        num: 'Количество',
        price: 'Цена',
        direction: 'Направление',
        time: 'Время',
        stall: 'Уровень',
        total: 'Итого',
        traded: 'Исполнено',
        action: 'Действие',
        undo: 'Отменить',
        delegationnum: 'Количество заявки',
        done: 'Исполнено',
        status: 'Статус',
        finished: 'Завершено',
        canceled: 'Отменено',
        parted: 'Частично',
        tip: 'Подсказка',
        buyamounttip: 'введите количество покупки',
        buyamounttipwarning: 'количество покупки превышает лимит',
        success: 'заявка успешно отправлена!',
        pricetip: 'введите цену покупки',
        pricetipwarning: 'цена покупки превышает лимит',
        sellamounttip: 'введите количество продажи',
        sellamounttipwarning: 'количество продажи превышает лимит',
        sellpricetip: 'введите цену продажи',
        sellpricetipwarning: 'цена продажи превышает лимит',
        undotip: 'Подтвердить отмену?',
        cancelsuccess: 'Ордер успешно отменен',
        marketprice: 'Рыночная цена',
        expand: {
            time: 'Время',
            price: 'Цена',
            amount: 'Сумма',
            fee: 'Комиссия',
        },
        realtime: 'в реальном времени',
        kline: 'График K-линии',
        depth: 'Глубина',
        open: 'Открыть',
        close: 'Закрыть',
        latestdeal: 'Последняя сделка',
        myswapaccount: 'Мой контрактный аккаунт',
        accountmode: 'Режим',
        accountmargin: 'Плечо',
        accountquanyi: 'Капитал',
        profitandloss: 'Нереализованная прибыль/убыток',
        principalAmount: 'Доступная маржа',
        positionAmount: 'Использованная маржа',
        frozenAmount: 'Замороженная маржа',
        principalRate: 'Коэффициент маржи',
        zijinhuazhuan: 'Перевод',
        up: 'Л',
        down: 'Ш',
        canup: 'Макс. Л',
        candown: 'Макс. Ш',
        cancloseup: 'Макс(Ш)',
        canclosedown: 'Макс(Л)',
        openup: 'Открыть лонг',
        opendown: 'Открыть шорт',
        closeup: 'Закрыть шорт',
        closedown: 'Закрыть лонг',
        currentposition: 'Открытые позиции',
        assetsdetail: 'Транзакции',
        marginMode1: 'Изолированная',
        marginMode2: 'Кросс',
        modifyMarginModeTitle: 'Изменить режим маржи аккаунта',
        modifyLeverage: 'Настроить плечо',
        moredetail: 'Показать больше',
        shareNumber: 'Конт',
        entrustprice: 'Цена',
        triggleprice: 'Триггер',
        openvolume: 'Объем лонга',
        closevolume: 'Объем шорта',
        triggleplaceholder: 'Цена по умолчанию рыночная',
        marketpriceplaceholder: 'Сделка будет выполнена по лучшей цене',
        levmaxtip: 'Плечо не должно превышать максимум',
        levmintip: 'Плечо не должно быть ниже минимума',
        marginModeSuccessTip: 'Изменено успешно.',
        noenoughbalance: 'Недостаточный баланс',
        pleaseinputopenvolume: 'Объем должен быть больше 0',
        pleaseinputcorrectopenvolume: 'Пожалуйста, введите корректный объем',
        pleaseinputrightentrustprice: 'Пожалуйста, введите корректную цену',
        noenoughposition: 'Недостаточная позиция',
        pleaseinputclosevolume: 'Объем должен быть больше 0',
        pleaseinputcorrectclosevolume: 'Пожалуйста, введите корректный объем',
        pos_Pl: 'Прибыль/убыток',
        pos_Ratio: 'Коэффициент прибыли/убытка',
        pos_pos: 'Позиция',
        pos_canClose: 'Доступная позиция',
        pos_openPrice: 'Цена открытия',
        pos_leverage: 'Плечо',
        pos_margin: 'Текущая маржа',
        pos_mRatio: 'Коэффициент маржи',
        pos_cmRatio: 'Поддерж. коэффициент',
        pos_long: 'Лонг',
        pos_short: 'Шорт',
        ent_entrustType: 'Открыть/Закрыть',
        ent_direction: 'Направление',
        ent_type: 'Тип',
        ent_trigglePrice: 'Цена триггера',
        ent_entrustPrice: 'Цена заявки',
        ent_tradedPrice: 'Цена сделки',
        ent_margin: 'Маржа',
        ent_volume: 'Объем',
        ent_status: 'Статус',
        ent_status1: 'В заявке',
        ent_status2: 'Отменено',
        ent_status3: 'Заявка не удалась',
        ent_status4: 'Исполнено',
        ent_statusblast: 'Ликвидация',
        ent_pl: 'Прибыль/убыток',
        ent_fee: 'Комиссия',
        triggerpriceshouldbigger: 'Цена триггера должна быть больше 0'
    },
    ctc: {
        title: 'Продажа в один клик - гарантия платформы - безопасность',
        desc: 'Криптоактивы управляются BIPPAX, а акцептор предоставляет услуги обмена.',
        buyin: 'Купить',
        sell: 'Продать',
        buyprice: 'Цена покупки',
        sellprice: 'Цена продажи',
        buynum: 'Количество покупки',
        sellnum: 'Количество продажи',
        payamount: 'Оплата',
        getamount: 'Оплата',
        avabalance: 'Доступно',
        time: 'Дата сделки',
        tip: 'Уведомление',
        notice: 'Уведомление',
        notice1: '1. Зона торговли фиатной валютой является сделкой активов между пользователями и акцепторами. Средства не переводятся на платформу, платформа не принимает пополнение/переводы в RMB',
        notice2: '2. Акцепторы фиатных сделок прошли реальную идентификацию, предоставляют торговую маржу, а токены хранятся на платформе, поэтому их конвертация обеспечена',
        notice3: '3. Время обслуживания акцептора: ежедневно 09:00-21:00. Принятие завершается в течение 30 минут после принятия ордера, незавершенная в течение двух часов сделка отменяется',
        notice4: '4. Для поддержки банковских карт в зоне фиатной торговли необходимо переводить средства с аккаунта, прошедшего вашу реальную идентификацию',
        notice5: '5. Для безопасности средств сделки фиатная торговля требует прохождения реальной идентификации',
        payType: 'Платежный аккаунт',
        receiveType: 'Аккаунт получения',
        moneyTips: 'Указанная выше цена только для справки. Ориентируйтесь на фактическую расчетную сумму после размещения ордера.',
        verifyset: 'Реальное имя/пароль активов',
        payset: 'Настройки оплаты',
        trade: ' Обмен',
        input50tips: 'Введите число от 50 до 50 000',
        bank: 'Банковская карта',
        alipay: 'Alipay',
        wechatpay: 'WeChat',
        payaccountset: 'Настройки платежного аккаунта',
        useselfaccount: 'Обязательно используйте аккаунт, подтвержденный вашим реальным именем.',
        orderSn: '№ ордера',
        tradetime: 'Дата обмена',
        direction: 'Направление',
        amount: 'Количество(USDT)',
        money: 'Итого(CNY)',
        price: 'Цена(CNY)',
        status: 'Статус',
        operate: 'Действие',
        moredetail: 'Подробнее'
    },
    cexchange: {
        title: 'Акция BZB',
        desc: 'Монета BZB - один клик - прибыль каждый день',
        quantity: 'Количество покупки в акции',
        inputtips1: 'Пользовательское количество',
        choosecurrency: 'Выберите валюту',
        all: 'Все',
        totalpay: 'Оплаченная сумма валюты',
        restricted: 'Общий лимит сегодня',
        currentprice: 'Текущая цена',
        nextprice: 'Цена следующего выпуска',
        confirmpay: 'Подтвердить оплату',
        assets: 'Активы',
        loginFirst: 'Пожалуйста, войдите',
        success: 'Поздравляем, обмен успешен!',
        tip: 'Подсказки',
        confirm: 'Подтвердить подсказки',
        confirmmsg: 'Вы уверены, что хотите обменять BZB?',
        ok: 'ОК',
        cancel: 'Отмена'
    },
    subscribe: {
        Su1: 'Страница деталей',

        Su2: 'Подписка',

        Su3: 'Подписка на новую валюту',

        Su4: 'Ожидает начала',

        Su5: 'В процессе',

        Su6: 'Будет объявлено',

        Su7: 'До',

        Su8: 'Начать',

        Su9: 'Цена выпуска',

        Su10: 'Ожидаемый коэффициент прибыли/убытка',

        Su11: 'Время начала',

        Su12: 'Время публикации',

        Su13: 'Детали',

        Su14: 'Подписка',

        Su15: 'Запись подписки',

        Su16: 'Название валюты',

        Su17: 'Цена выпуска',

        Su18: 'Цена выпуска',

        Su19: 'Количество выигрышных заявок',

        Su20: 'Сумма возврата',

        Su21: 'Время',

        Su22: 'Статус',

        Su23: 'Время',

        Su24: 'Сумма подписки',

        Su25: 'Валюта подписки',

        Su26: 'Цена выпуска',

        Su27: 'Ожидаемая прибыль/убыток',

        Su28: 'Лимит подписки',

        Su29: 'Время начала подписки',

        Su30: 'Время окончания подписки',

        Su31: 'Время публикации результатов',

        Su32: 'Ожидаемое время запуска',

        Su33: 'Сумма подписки',

        Su34: 'Валюта',

        Su35: 'Сумма подписки',

        Su36: 'Время подписки',

        Su37: 'Статус',

        Su38: 'Будет объявлено',

        Su39: 'Опубликовано',

        Su40: 'Информация о проекте',

        Su41: 'Доступный баланс',

        Su42: 'Подать заявку сейчас',

        Su43: 'Все',

        Su44: 'Платежный пароль',

    },
    option: {
        minute: 'мин',
        enter: 'Пожалуйста, введите',
        title: 'Опционный контракт',
        buyupreward: 'Пул наград покупки',
        buydownreward: 'Пул наград продажи',
        quantity: 'Сумма ставки',
        myamount: 'Моя сумма ставки',
        buyup: 'Рост',
        buydown: 'Падение',
        history: 'История',
        seriers: '№',
        period: "",
        currentoption: 'Диапазон времени',
        openprice: 'Цена открытия',
        currentprice: 'Текущая цена',
        openprice1: 'Цена открытия',
        closeprice: 'Цена закрытия',
        opentime: 'Время открытия',
        closetime: 'Время закрытия',
        progress: 'Прогресс',
        loginFirst: 'Пожалуйста, сначала войдите!',
        selectAmount: 'Пожалуйста, выберите сумму',
        balancenotenough: 'Недостаточный баланс!',
        betsuccess: 'Поздравляем! Ставка успешна!',
        noopening: 'Сейчас нет открытия!',
        col_createTime: 'Время создания',
        col_direction: 'Направление',
        col_result: 'Результат',
        col_optionNo: '№',
        col_betAmount: 'Сумма ставки',
        col_rewardAmount: 'Сумма награды',
        col_fee: 'Комиссия открытия',
        col_winfee: 'Комиссия награды',
        win: 'Выигрыш',
        lose: 'Проигрыш',
        wait: 'Открытие',
        avaliablebalance: 'Доступный баланс',
        login: 'Пожалуйста, войдите',
        kline: 'Котировки в реальном времени',
        or1: 'Текущая цена',
        or2: 'Время ставки',
        or3: 'Сумма ставки',
        or4: 'Валюта ставки',
        or5: 'Другая сумма',
        or6: 'Текущая цена является ценой исполнения',
        or7: 'История торговли',
        or8: 'Коэффициенты',
        or9: 'Бонус',
        or10: 'Запись торговли',
        or11: 'Выберите 4 обычные суммы ставки USDT',
    },
    otc: {
        ad: 'Реклама',
        buyin: 'Купить',
        sellout: 'Продать',
        merchant: 'Мерчант',
        applymerchant: 'Подать заявку мерчанта',
        volume: 'Объем',
        paymethod: 'Способ оплаты',
        amount: 'Количество',
        price_coin: 'Цена/монета',
        operate: 'Действие',
        validate: 'Пожалуйста, сначала пройдите проверку',
        sell: 'продать',
        buy: 'купить',
        transaction: 'Торговые операции',
        buttontxt: 'Стать мерчантом',
        title: 'OTC обмен',
        desc: 'Удобная, безопасная и быстрая продажа цифровой валюты',
        title1: 'Динамическая настройка',
        desc1: 'Колебания в реальном времени согласно рыночной цене',
        title2: 'Без комиссии',
        desc2: 'Что вы видите, то и получаете. Кроме цены продажи, платформа не взимает сервисную комиссию',
        title3: 'Мгновенная сделка',
        desc3: 'Платформа предоставляет сервисы для мерчантов: интеллектуальное сопоставление и закрытие ордеров без ожидания ручного подбора',
        title4: 'Гарантия платформы',
        desc4: 'Сертифицированный платформой бизнес, безопасность гарантирована, служба поддержки 24 часа сопровождает сделки',
        myad: {
            title: 'Моя реклама',
            post: 'Опубликовать объявление',
            alert: '【Подсказка】: когда минимальная сумма покупки по объявлению плюс комиссия превышает оставшееся количество объявления, объявление автоматически снимается.',
            no: 'нет',
            type: 'тип',
            sell: 'продать',
            buy: 'купить',
            limit: 'лимит',
            remain: 'остаток',
            coin: 'монета',
            created: 'дата создания',
            operate: 'действие',
            errmsg: 'Можно редактировать и изменять после снятия объявления',
            update: 'редактировать',
            shelf: 'выставить',
            dropoff: 'снять',
            delete: 'удалить',
        },
        myorder: 'Мой ордер',
        chatline: {
            status_1: 'Покупатель еще не оплатил, ожидайте оплату покупателя!',
            status_2: 'Покупатель оплатил, ожидается выпуск продавцом!',
            status_3: 'Ордер завершил сделку!',
            status_4: 'По ордеру идет апелляция!',
            status_5: 'Ордер отменен!',
            loadmore: 'Загрузить еще',
            warning: 'Предупреждение о мошенничестве: в последнее время мошенники неоднократно использовали банковские реквизиты и поддельные подтверждения переводов. Обязательно проверяйте номер своего платежного счета, защищайте переводимые средства и избегайте риска блокировки банковской карты!',
            contenttip: 'Введите сообщение чата, нажмите Enter для отправки',
            contentmsg: 'Сообщение не может быть пустым',
        },
        chat: {
            seller: 'Продавец',
            buyer: 'Покупатель',
            exchangeamount: 'Сумма обмена',
            operatetip: 'Подсказка операции',
            operatetip_1: 'Завершите оплату на счет, указанный другой стороной, в установленный срок и нажмите на этой странице.',
            finishpayment: 'оплата завершена',
            operatetip_1_1: 'При переводе укажите в комментарии корректный номер платежной ссылки',
            operatetip_1_2: 'После получения оплаты продавец подтвердит платеж на сайте. Система автоматически отправит купленные цифровые активы на ваш аккаунт. Обратите внимание:',
            note: 'Примечание',
            notetip: 'Не используйте другие программы чата для общения и не принимайте документы, вложения электронной почты и другие файлы от другой стороны. Вся коммуникация должна проходить в окне чата на этой странице.',
            operatetip_2_1: 'Проданные вами цифровые активы переданы платформе на хранение и заморозку. После подтверждения оплаты нажмите',
            operatetip_2_2: 'Не доверяйте просьбам срочно выпустить валюту. Сначала подтвердите получение средств, затем выпустите цифровые активы, чтобы избежать потерь!',
            operatetip_2_3: 'После получения SMS от счета обязательно войдите в интернет-банк или мобильный банк и подтвердите поступление платежа, чтобы избежать ошибочного выпуска цифровых активов из-за мошеннических сообщений!',
            confirmrelease: 'Подтвердить выпуск',
            paydigital: 'Оплатить цифровые активы',
            orderstatus: 'Статус ордера',
            orderstatus_1: 'оплата завершена',
            orderstatus_2: 'Апелляция ордера',
            orderstatus_3: 'Подтвердить выпуск',
            orderstatus_4: 'отменить сделку',
            orderstatus_5: 'Апелляция ордера',
            order: 'Ордер',
            and: 'и',
            transition: 'обмен',
            transprice: 'Цена сделки',
            transnum: 'Количество сделки',
            transmoney: 'Сумма сделки',
            tip1: 'Пользователь еще не добавил номер банковской карты',
            tip2: 'Пользователь пока не добавил аккаунт Alipay',
            tip3: 'Пользователь еще не добавил аккаунт WeChat',
            zfb: 'Alipay',
            wx: 'WeChat',
            qrcode: 'QR-код',
            msg1: 'Вы уверены, что оплатили?',
            msg2: 'Платежи не возвращаются! Вы уверены, что хотите отменить ордер?',
            msg3: '【Повтор】: платежи не возвращаются! Вы уверены, что хотите отменить ордер?',
            msg4: 'Оплачено, не получено',
            msg5: 'Уже оплачено, не получено',
            tip: 'Подсказка',
            comptype: 'Тип жалобы',
            compremark: 'Примечание жалобы',
            willcomp: 'Хочу пожаловаться',
            msg6: 'Вы подтверждаете выпуск валюты?',
            result_1: 'ожидание оплаты',
            result_2: 'Ожидание выпуска',
            result_3: 'Завершено',
            result_4: 'В апелляции',
            result_5: 'Отменено',
            msg7: 'Пароль средств',
            msg7tip: 'пожалуйста, введите пароль средств',
        },
        checkuser: {
            emaildone: 'Эл. почта подтверждена',
            emailundo: 'Эл. почта не подтверждена',
            teldone: 'Телефон подтвержден',
            telundo: 'Телефон не подтвержден',
            idcarddone: 'ID-карта подтверждена',
            idcardundo: 'ID-карта не подтверждена',
            language: 'язык',
            languagetext: 'Китайский',
            registtime: 'Время регистрации',
            exchangetimes: 'Накопленные сделки',
            exchangeinfo: 'Информация о торговле',
            tablabel1: 'Продажа онлайн',
            tablabel2: 'Покупка онлайн',
            col_symbol: 'Монета',
            col_paymode: 'Способ оплаты',
            col_num: 'Количество',
            col_price: 'Цена',
            col_created: 'Время выпуска',
            col_operate: 'Действие',
            operatemsg: 'Сначала пройдите проверку реального имени',
            buyin: 'Купить',
            sellout: 'Продать',
        },
        tradecenter: {
            postad: 'Опубликовать объявление',
            exchange: 'Сделка GCC',
            buyin: 'Хочу купить',
            sellout: 'Хочу продать',
        },
        tradeinfo: {
            emaildone: 'Эл. почта подтверждена',
            emailundo: 'Эл. почта не подтверждена',
            teldone: 'Телефон подтвержден',
            telundo: 'Телефон не подтвержден',
            idcarddone: 'ID-карта подтверждена',
            idcardundo: 'ID-карта не подтверждена',
            exchangetimes: 'Количество обменов',
            price: 'Цена',
            num: 'Количество',
            paymethod: 'Способ оплаты',
            exchangelimitamount: 'Лимит обмена',
            location: 'Местоположение',
            location_text: 'Китай',
            exchangeperiod: 'Период обмена',
            minute: 'мин',
            amounttip: 'Введите сумму',
            numtip: 'Введите количество',
            remarktip: 'Сообщите ваши требования',
            remarktitle: 'Примечания',
            exchangetitle: 'Информация о торговле',
            exchange_tip1: 'После создания запроса на сделку цифровая валюта блокируется на хранении и защищается платформой. Если вы продавец, после создания запроса вы можете пополнить счет и ждать оплаты покупателя. Покупатель оплачивает в установленный срок. После получения оплаты вы должны выпустить цифровую валюту, находящуюся на хранении.',
            exchange_tip2: 'Перед торговлей прочитайте《Условия обслуживания сети платформы》, Частые вопросы, торговые руководства и другую справочную документацию.',
            exchange_tip3: 'Остерегайтесь мошенников! Перед сделкой проверьте рейтинг пользователя и уделяйте больше внимания новым аккаунтам.',
            exchange_tip4: 'Обратите внимание: округление и колебания цены могут повлиять на итоговое количество цифровой валюты в сделке. Введенная фиксированная сумма определяет итоговую сумму, а количество цифровой валюты рассчитывается по мгновенному курсу в момент отправки запроса.',
            exchange_tip5: 'Сервис хранения защищает покупателей и продавцов онлайн-сделок. В случае спора мы оценим всю предоставленную информацию и выпустим удерживаемую цифровую валюту законному владельцу.',
            warning1: 'Введите до 2 десятичных знаков',
            warning2: 'Сумма ордера',
            warning3: 'Введите до 8 десятичных знаков',
            warning4: 'Количество ордера',
            confirmbuyin: 'Подтвердить покупку',
            confirmsellout: 'Подтвердить продажу',
            buyin: 'Купить',
            sellout: 'Продать',
            warning5: 'Пожалуйста, заполните ордер согласно требованиям',
        },
        publishad: {
            createad: 'Создать торговое объявление',
            msg1: 'Если вы часто торгуете, вы можете создать собственное торговое объявление. Если торгуете редко, рекомендуем искать напрямую',
            msg2: 'Создание торгового объявления',
            msg3: 'Бесплатно',
            msg4: 'Если хотите напрямую редактировать созданные объявления, проверьте',
            tradead: 'Торговая реклама',
            myad: 'Моя реклама',
            iwant: 'Я хочу',
            sellonline: 'продать онлайн',
            buyonline: 'купить онлайн',
            exchangecoin: 'Монета обмена',
            country: 'Страна',
            currency: 'Монета',
            openfixedprice: 'Открыть фиксированную цену',
            open: 'Открыть',
            close: 'Закрыть',
            usetip: 'После включения цена вашей валюты не будет колебаться вместе с рынком и не изменится.',
            premiseprice: 'Премия',
            premisepricetip: 'Установите премию',
            fixedprice: 'фиксированная цена',
            fixedpricetip: 'Введите цену обмена',
            marketprice: 'Рыночная справочная цена',
            marketpricetip: 'Премия означает, на сколько процентов цена выше текущей рыночной цены',
            exchangeprice: 'Цена обмена',
            formual: 'Формула цены',
            num: 'Количество',
            num_text1: 'Введите желаемое',
            num_text2: 'количество',
            exchangeperiod: 'Период сделки',
            exchangeperiod_text1: 'Введите срок сделки',
            minute: 'мин',
            tip1: 'Сколько времени покупатель может принять сделку, введите целое число',
            tip2: '【Подсказка】Можно привязать в личном центре / Добавить способ оплаты',
            tip3: 'Введите минимальную сумму сделки',
            tip4: 'Введите максимальную сумму сделки',
            tip5: 'В примечаниях можно указать особые требования, например требования к покупателю, время онлайн и т. д.',
            paymode: 'Способ оплаты',
            minlimit: 'Минимальная сумма сделки',
            maxlimit: 'Максимальная сумма сделки',
            remark: 'Примечания',
            openautoreply: 'Включить автоответ',
            msg5: 'После включения, когда пользователь инициирует сделку через это объявление, система автоматически отправит другой стороне выбранный вами автоответ.',
            autoreply: 'Автоответ',
            autoreplytip: 'После получения ордера информация автоматически отправляется покупателю, например способ оплаты, номер счета получения и т. д.',
            fundpwd: 'Пароль средств',
            fundpwdtip: 'Введите пароль средств',
            submit: 'Отправить',
            warning1: 'Введите корректное число',
            warning2: 'Допустимое значение 0-20',
            warning3: 'Введите максимальную сумму сделки!',
            warning4: 'Введите целое число',
            warning5: 'Максимальная сумма сделки должна быть больше минимальной!',
            warning6: 'Максимальная сумма сделки не может превышать общий объем продажи',
            warning7: 'Введите минимальную сумму сделки!',
            warning8: 'Минимальная сумма сделки должна быть больше или равна 100!',
            warning9: 'Минимальная сумма сделки должна быть меньше максимальной',
            sellout: 'Продать',
            buyin: 'Купить',
            inputtip1: 'Введите валюту',
            inputtip2: 'Введите корректный вариант',
            inputtip3: 'Допустимое значение 0-20 и не может быть 0',
            inputtip4: 'Введите корректную фиксированную цену',
            inputtip5: 'Введите корректное число, максимальное количество сделок не должно превышать 100',
            inputtip6: 'Введите корректный срок сделки',
            inputtip7: 'Выберите способ сделки',
            inputtip8: 'Введите пароль средств',
            zfb: 'Alipay',
            wx: 'WeChat',
            unionpay: 'UnionPay',
            submit_failure: 'Ошибка!',
            submittip1: 'Пожалуйста, пройдите ряд проверок, включая реальное имя',
            submittip2: 'Пожалуйста, пройдите ряд проверок, включая мобильный телефон',
            submittip3: 'Пожалуйста, пройдите ряд проверок, включая пароль средств',
            submittip4: 'Пожалуйста, привяжите хотя бы один способ оплаты',
        },
        index: {
            title: 'Рекомендуемые объявления',
            exchangetimes: 'Количество сделок',
            exchangeprice: 'Цена сделки',
            exchangelimit: 'Лимит сделки',
            paymode: 'Способ оплаты',
            buy: 'купить',
            sell: 'продать',
            viewmore: 'Больше',
            bot1: 'Безопасно и надежно',
            bot1_tip: 'Более 10 лет опыта команды финансового риск-контроля\\nНастраиваемая система политики безопасности',
            bot2: 'Быстро и удобно',
            bot2_tip: 'Поддержка бесплатного P2P-режима сделок пользователей\\nРазные каналы обмена средств',
            bot3: 'Полная валюта',
            bot3_tip: 'Выбор популярных валют цифровых активов\\nОпыт торговли несколькими активами',
            ibuy: 'Хочу купить',
            isell: 'Хочу продать',
        }
    },
    activity: {
        all: 'Все',
        prepare: 'Скоро',
        ongoing: 'В процессе',
        distributing: 'Распределение',
        completed: 'Завершено',
        progress: 'Прогресс',
        totalsupply: 'Общее предложение',
        starttime: 'Дата начала',
        endtime: 'Дата окончания',
        viewdetail: 'Детали',
        attend: 'Участвовать',
        tokendistribute: 'Распределение токенов',
        baseinfo: 'Информация об акции',
        status: 'Статус',
        activitytype: 'Тип акции',
        activitytype0: 'Неизвестно',
        activitytype1: "Список (FOF)",
        activitytype2: "Список (AVA)",
        activitytype3: "Разделение держателей",
        activitytype4: "Бесплатная покупка",
        activitytype5: "Покупка майнинга",
        activitytype6: "Заблокировано",
        ruledetail: 'О правилах',
        publishprice: 'Цена публикации',
        activitycoin: 'Символ монеты акции',
        accpetcoin: 'Символ принимаемой монеты',
        holdcoin: 'Символ удерживаемой монеты',
        limittimes: 'Личный лимит раз',
        limitamount: 'Личный лимит суммы',
        unlimited: 'Без ограничений',
        alreadyamount: 'Уже продано',
        leftamount: 'Остаток',
        attention: 'Внимание',
        attentiontxt1: '1、После подачи заявки на участие в акциях типа [разделение склада] и [бесплатная подписка] активы будут заморожены до завершения разморозки.',
        attentiontxt2: '2、После участия в акциях типа Holder Divide и Free Buy пользователи не могут отозвать заявку.',
        attentiontxt3: '3、Если акция отменена из-за стороны проекта или иных факторов непреодолимой силы, замороженные активы возвращаются исходным способом.',
        attentiontxt4: '* Право окончательного толкования этой акции принадлежит BIPPAX.',
        inputamount: 'Введите сумму',
        inputholdamount: 'Введите сумму блокировки',
        mybalance: 'Доступный баланс',
        holdtips: '[Разделение держателей] требует блокировки до окончания акции.',
        pleaseinputamount: 'Пожалуйста, введите сумму!',
        pleaseinputholdamount: 'Пожалуйста, введите сумму удержания!',
        commitfailed: 'Отправка не удалась!',
        minlimitamountfailed: 'Количество обмена не должно быть меньше минимального количества обмена!',
        maxlimitamountfailed: 'Сумма обмена не должна превышать максимальную сумму покупки!',
        limittimesfailed: 'Вы превысили максимальное количество индивидуальных покупок!',
        balancenotenough: 'Недостаточный баланс!',
        headertitledesc: 'Открытые лаборатории для взаимовыгодного сотрудничества инвесторов, проектов и бирж',
        currentdivided: 'Моя текущая позиция получит',
        leveloneCount: 'Лимит количества первого уровня',
        submit: 'Отправить',
        tipsmobile: 'Пожалуйста, используйте веб-версию ПК (www.BIPPAX.com)',
        tipsmobile1: 'Вы можете войти в веб-версию ПК для участия в акции.',
        intvalue: 'Введите целое число',
        inputminingamount: 'Введите количество покупки',
        moreactivity: 'Больше акций',
        releaseType: 'Тип выпуска',
        releaseType0: 'Равный выпуск',
        releaseType1: 'Пропорциональный выпуск',
        lock: 'Блокировка ',
        releaseDetail: 'Детали выпуска',
        lockday: ' дней',
        lockweek: ' недель',
        lockmonth: ' месяцев',
        lockyear: ' лет',
        releasePercent: 'Процент выпуска',
        lockFee: 'Комиссия блокировки',
        releaseTimes: 'Число выпусков',
        times: 'раз'
    },
    invite: {
        myinvitelink: 'Промо-ссылка',
        copy: 'Копировать',
        copyed: 'Скопировано',
        mylevelone: 'Друзья первого уровня',
        myleveltwo: 'Друзья второго уровня',
        mycommission: 'Комиссионный доход(USDT)',
        extrareward: 'Дополнительные награды',
        partnerlevel: 'Уровень партнерства',
        ruledetail: 'Детали правил',
        ruleprofile1: '[Партнер по продвижению] получает самый высокий процент онлайн-комиссии и самый длительный срок возврата комиссии (максимум пожизненная комиссия). Промоутеры, приложившие соответствующие усилия, могут стать настоящими партнерами платформы и получать дивиденды от совместного роста с BIPPAX. Подробные правила ниже:',
        ruleprofile2: "",
        ruleprofile3: "",
        ruleprofile4: "",
        ruletext1: '1. Для продвижения концепции цифровых активов и расширения базы пользователей BIPPAX запустила долгосрочную программу «Партнер по продвижению».',
        ruletext2: '2. Приглашенные друзья делятся на два уровня. Если A приглашает B, то B является другом первого уровня A. Если B приглашает C, то C является другом первого уровня B и другом второго уровня A.',
        ruletext3: '3. При регистрации друзей друзья первого уровня могут быть привязаны только по ссылке приглашения или при ручном вводе кода приглашения приглашающего.',
        ruletext4: '4. После регистрации приглашенного по коду приглашения и прохождения проверки реального имени комиссионное вознаграждение вступает в силу.',
        ruletext5: '5. Срок комиссии составляет N месяцев с момента прохождения приглашенным проверки реального имени. Процент комиссии зависит от уровня.',
        ruletext6: '6. Комиссионные активы продвижения формируются из торговых комиссий нижестоящих друзей в трех базовых рыночных валютах: USDT, BTC и ETH.',
        ruletext7: '7. Процент и срок комиссии продвижения положительно связаны с количеством друзей первого уровня. Чем больше приглашений, тем выше доступный процент комиссии. Конкретные коэффициенты возврата комиссии следующие:',
        ruletext8: '8. TOP10 или TOP100 время от времени получают дополнительные награды от MKWORLDS.',
        ruletext9: '9. Если другие акции конфликтуют с программой партнера по продвижению, после консультации условия могут временно изменяться; просим партнеров отнестись с пониманием.',
        ruletext10: '10. Партнеры уровней L4 (Xunfu), L5 (Taishou) и L6 (Jiedushi) имеют право соответственно на 5%, 10% и 15% бонусов от общего годового возврата комиссии.',
        ruletext11: '11. Право окончательного толкования этой акции принадлежит BIPPAX.',
        ruleexampletitle: 'Например:',
        ruleexamplecontent1: 'Если пользователь Xiaoyan пригласил 100 друзей первого уровня, а каждый из них пригласил 5 друзей второго уровня, у Xiaoyan будет 100 друзей первого уровня и 500 друзей второго уровня. Если каждый в среднем торгует на 3000 юаней в день, месячный доход Xiaoyan составит примерно (100 * 3000 * 0.001 * 30% + 500 * 3000 * 0.001 * 10%) * 30 = 7200 в месяц.',
        ruleexamplecontent2: 'Если пользователь Xiaoyan пригласил 1000 друзей первого уровня, а каждый из них пригласил 5 друзей второго уровня, у Xiaoyan будет 1000 друзей первого уровня и 5000 друзей второго уровня. Если каждый в среднем торгует на 3000 юаней в день, месячный доход Xiaoyan составит примерно (1000*3000*0.001*50%+5000*3000*0.001*20%)*30=135000 в месяц.',
        lastupdate: 'Последнее обновление',
        laststastic: 'Последняя статистика',
        level: 'Уровень',
        lv1: "Lizheng",
        lv2: "Xianling",
        lv3: "Zhifu",
        lv4: "Xunfu",
        lv5: "Taishou",
        lv6: "Jiedushi",
        levelonecount: 'Количество первого уровня',
        levelonecommission: 'Коэффициент возврата первого уровня / срок возврата',
        leveltwocommission: 'Коэффициент возврата второго уровня / срок возврата',
        partnerdivide: 'Дивиденды партнера',
        month: 'Месяцы',
        alllife: 'Пожизненно',
        totalcommissionrank: 'Продвижение общей комиссии',
        rank: '№',
        userid: 'ID пользователя',
        rankday: '(День)',
        rankweek: '(Неделя)',
        rankmonth: '(Месяц)',
        rankall: '(Все)',
        promotioncount: 'Количество продвижений',
        commissionusdt: 'Комиссия(USDT)',
        ranktip1: 'Количество приглашений равно количеству друзей первого уровня. В этом списке общий объем комиссий отсортирован от большего к меньшему.',
        ranktip2: 'Количество приглашений равно количеству друзей первого уровня. Список отсортирован по количеству приглашенных друзей первого уровня.',
        thanks: 'Спасибо за поддержку BIPPAX!',
        headertip: 'Данные выше не обновляются в реальном времени. Система обновляет статистику каждые 24 часа.',
        ptools: 'Инструменты продвижения',
        pt_title: 'Подарочная карта криптовалюты',
        pt_desc: 'Это сюрприз из будущего для друзей, родственников, клиентов и партнеров.',
        pt_more: 'Скоро появятся новые инструменты',
        pt_tips: 'Если у вас есть хорошая идея, отправьте письмо на promotion@BIPPAX.com; после принятия предусмотрена награда!',
        pt_card_amount: 'Сумма карты',
        pt_card_deadline: 'Срок',
        pt_card_noend: 'Бессрочно',
        pt_card_btn: 'Получить 30 карт бесплатно (≈2000 CNY)',
        pt_card_btn_login: 'Пожалуйста, сначала войдите',
        pt_card_rule: 'Детали правил',
        pt_card_summary: 'Подарочная карта цифровой валюты — инструмент продвижения, созданный для того, чтобы партнеры могли лучше приглашать офлайн-друзей. При обмене подарочной карты пользователь автоматически становится офлайн-другом партнера по продвижению.',
        pt_card_rule1: '1. Бесплатные подарочные карты ограничены 30 картами на пользователя. Если нужно выпустить больше карт, требуется платная настройка: сумма карты, LOGO, инструкции и т. д. По вопросам настройки отправьте письмо на',
        pt_card_rule2: '2. Бесплатные подарочные карты ограничены одним комплектом на пользователя. Бесплатные карты, выпущенные BIPPAX, доступны каждому пользователю только один раз. Даже если разные пользователи получают бесплатные карты с разными кодами обмена, обменять можно только одну. Пользовательские карты этим ограничением не ограничены.',
        pt_card_rule3: '3. До обмена подарочной карты, если у пользователя нет приглашающего (код приглашения не был введен при регистрации аккаунта), он автоматически связывается как друг первого уровня эмитента карты. Если A не ввел код приглашения при регистрации, он не относится к чьим-либо друзьям первого или второго уровня; но после обмена карты, выпущенной B, A автоматически становится другом первого уровня B.',
        pt_card_rule4: '4. Для предотвращения злоупотреблений номинал подарочной карты не выплачивается в реальном времени. После получения он замораживается на 180 дней и автоматически поступает на баланс пользователя через 180 дней.',
        pt_card_rule5: '5. Для получения бесплатных подарочных карт нужно пройти проверку реального имени. При обмене их можно получить без завершения проверки, чтобы промоутеры быстрее получали нижестоящих друзей.',
        pt_card_rule6: '6. Право окончательного толкования бесплатных подарочных карт принадлежит BIPPAX.PRO.',
        pt_card_day: 'Дни',
        pt_card_title_tips: 'Бесплатный промо-грант 2000 CNY',
        pt_card_receivew_success: 'Поздравляем! Подарочные карты партнера по продвижению успешно получены! Перейдите в Личный центр -> Центр карт и купонов.',
        usepromotion: 'Использовать промоматериалы',
        saveimage: 'Сохранить изображение',
        imagetips: 'Если не удается скачать изображения, используйте инструмент скриншота!',
        pt_invite_title: 'Листовка регистрации по приглашению',
        pt_invite_desc: 'Автоматически становится нижестоящим другом через регистрацию по QR-коду, подходит для пересылки в группы и форумы.',
        colum_text0: 'Ранг',
        colum_text1: 'Участник',
        colum_text2: 'Продвижение',
        colum_text3: 'Комиссия(USDT)',
        colum_text4: 'Доп. награда',
        context_title: 'Эксклюзивный код обмена для партнеров по продвижению',
        context_title1: 'Сканируйте, чтобы узнать больше',
        context_title2: 'Мой код приглашения',
        context_title3: 'Изображение приглашения'
    },
    uc: {
        verify: 'Сначала завершите KYC',
        login: {
            noaccount: 'Нет аккаунта?',
            register: 'Регистрация',
            login: 'Войти',
            welcomelogin: 'Добро пожаловать',
            usertip: 'Введите эл. почту',
            pwdtip: 'Введите пароль',
            validatecodeload: 'Загрузка кода проверки',
            validatemsg: 'Сначала завершите проверку',
            forget: 'Забыли пароль?',
            loginvalidate: 'Введите эл. почту или номер телефона',
            pwdvalidate1: 'Введите пароль',
            pwdvalidate2: 'Длина пароля не менее шести символов',
            success: 'Успешно',
            goregister: 'К регистрации',
            getlostpwd: 'Забыли пароль'
        },
        forget: {
            title: 'Найти пароль',
            hasaccount: 'Уже есть аккаунт? Войти',
            login: 'Войти',
            sendcode: 'Отправить',
            newpwd: 'Введите новый пароль',
            confirmpwd: 'Введите новый пароль еще раз',
            save: 'Отправить',
            pwdvalidate1: 'Введите подтверждение пароля',
            pwdvalidate2: 'Пароли не совпадают!',
            resettelpwd: 'Сбросить пароль телефона',
            resetemailpwd: 'Сбросить пароль эл. почты',
            newpwdtip: 'Введите новый пароль',
            pwdvalidate3: 'Длина пароля не менее шести символов',
            telno: 'Номер телефона',
            mtelno: 'Аутентификация мобильного телефона',
            memail: 'Аутентификация почты',
            smscode: 'SMS-код проверки',
            teltip: 'Введите телефон',
            smscodetip: 'Введите SMS-код проверки',
            email: 'Эл. почта',
            emailcode: 'Код проверки эл. почты',
            emailtip: 'Введите эл. почту',
            emailcodetip: 'Введите код проверки email',
            resetpwdsuccess: 'Пароль успешно сброшен',
            smswarn: 'Проверьте SMS',
        },
        finance: {
            fi1: 'Скрыть мелкие активы',
            center: 'Финансовый центр',
            personalassets: 'Валютные активы',
            swapassets: 'Контрактные активы',
            billdetail: 'Детали счета',
            charge: 'Депозит',
            pickup: 'Вывод',
            tradetail: 'Торговый майнинг',
            paydividends: 'Выплата дивидендов',
            invitingmining: 'Награды за приглашения',
            money: {
                M1: 'Полученное количество',

                M2: 'Количество перевода на вывод',

                M3: 'Курс обмена',
                cointype: 'Монета',
                balance: 'Баланс',
                frozen: 'Замороженный баланс',
                operate: 'Действие',
                charge: 'Депозит',
                pickup: 'Вывод',
                onkeytrans: 'Перевод',
                getaddress: 'Получить адрес',
                resetsuccess: 'Сброс успешен',
                match: 'Сопоставить',
                matchtip1: 'Доступная сумма сопоставления GCX',
                matchtip2: 'Введите сумму сопоставления',
                matcherr1: 'Введите корректное количество!',
                matcherr2: 'Превышено максимальное число сопоставлений!',
                matchsuccess: 'Сопоставление успешно!',
                needreleased: 'Активы к выпуску',
                totalassets: 'Оценочная общая стоимость активов:'
            },
            swap: {
                totalassets: 'Оценочная общая стоимость активов:',
                swap: ' Контракт',
                swaptype: 'SWAP',
                swapassets: 'Капитал аккаунта',
                avabalance: 'Доступная маржа',
                usebalance: 'Использованная маржа',
                frozenbalance: 'Замороженная маржа',
                profitandloss: 'Нереализованная прибыль/убыток',
                transfor: 'Перевод',
                inputtransferamount: 'Сумма перевода',
                all: 'Все',
                currencyaccount: 'Спотовый аккаунт',
                swapaccount: 'Аккаунт бессрочных контрактов',
                clickchange: 'Нажмите, чтобы изменить направление',
                avaamount: 'Доступно',
                pleaseselectwallet: 'Сначала выберите кошелек перевода.',
                pleaseinputamount: 'Введите сумму перевода',
                oktransfer: 'Перевести сейчас'
            },
            trade: {
                start_end: 'Начало-Конец',
                account_date: 'Время получения средств',
                to: 'До',
                operatetype: 'Тип действия',
                search: 'Поиск',
                charge: 'Пополнение',
                pickup: 'Вывод',
                transaccount: 'Перевод',
                exchange: 'Обмен',
                otcbuy: 'OTC-Покупка',
                otcsell: 'OTC-Продажа',
                activityaward: 'Награда акции',
                promotionaward: 'Награда продвижения',
                dividend: 'Дивиденд',
                vote: 'Голосование',
                handrecharge: 'Ручное пополнение',
                match: 'Сопоставить',
                activitybuy: 'Покупка акции',
                ctcbuy: 'CTC-Покупка',
                ctcsell: 'CTC-Продажа',
                chargetime: 'время создания ордера',
                type: 'Тип',
                num: 'Количество',
                status: 'Статус',
                finish: 'Завершено',
                fee: 'Возврат комиссии майнинга',
                transactionTime: 'Время торговли',
                symbol: 'Валютная пара',
                direction: 'Направление',
                price: 'Цена',
                entrustment: 'Заявка',
                havedeal: 'Сделка выполнена',
                poundageAmount: 'Сервисная комиссия ',
                exchangeOrderId: 'ID ордера',
                mineAmount: 'Добыть валюту (BHB)',
                buy: 'КУПИТЬ',
                sell: 'ПРОДАТЬ',
                limit: 'ЛИМИТ',
                market: 'РЫНОК',
                clear: 'Очистить условие',
                turnover: 'Оборот'
            },
            paydividende: {
                money_holding: 'Возврат распределения средств накоплен(ETH): ',
                money_hold: 'Дивиденды к возврату(ETH): ',
                paydividends: 'Выплатить дивиденды(ETH)',
                account_date: 'Время получения средств',
                datehodld: 'Дата удержания средств',
                start_end: 'Начало-Конец',
                to: 'До',
                operatetype: 'Тип действия',
                search: 'Поиск',
                charge: 'Пополнение',
                pickup: 'Вывод',
                transaccount: 'Перевод',
                exchange: 'Обмен',
                otcbuy: 'OTC-Покупка',
                otcsell: 'OTC-Продажа',
                activityaward: 'Награда акции',
                promotionaward: 'Награда продвижения',
                dividend: 'Дивиденд',
                vote: 'Голосование',
                handrecharge: 'Ручное пополнение',
                match: 'Сопоставить',
                chargetime: 'Время пополнения',
                type: 'Тип',
                num: 'Количество',
                status: 'Статус',
                finish: 'Завершено',
                fee: 'Комиссия',
                symbol: 'Символ монеты',
            },
            record: {
                Please: 'Выберите диапазон дат поиска',
                start_end: 'Начало-Конец',
                to: 'До',
                operatetype: 'Тип действия',
                search: 'Поиск',
                charge: 'Пополнение',
                pickup: 'Вывод',
                transaccount: 'Перевод',
                exchange: 'Обмен',
                otcbuy: 'OTC-Покупка',
                otcsell: 'OTC-Продажа',
                activityaward: 'Награда акции',
                promotionaward: 'Награда продвижения',
                dividend: 'Дивиденд',
                vote: 'Голосование',
                handrecharge: 'Ручное пополнение',
                match: 'Сопоставить',
                chargetime: 'Время пополнения',
                type: 'Тип',
                num: 'Количество',
                status: 'Статус',
                finish: 'Завершено',
                fee: 'Комиссия',
                shouldfee: 'Комиссия к оплате',
                revenue: 'Тип дохода/расхода',
                re1: 'Вход',
                re2: 'Выход',
                discountfee: 'Списанная комиссия',
                realfee: 'Сервисная комиссия',
                symbol: 'Символ монеты',
                activitybuy: 'Покупка акции',
                ctcbuy: 'C2C ПОКУПКА',
                ctcsell: 'C2C ПРОДАЖА',
                redout: "RED-OUT",
                redin: "RED-IN",
                quickExchange: 'Быстрый обмен',
                currentRate: 'Текущий курс обмена',
                from: 'От',
                inputexchangeamount: 'Введите сумму быстрого обмена',
                inputexchangepasswd: 'Введите пароль обмена',
                chooseTransCoinUnit: 'Выберите монету перевода',
                inputTransAmount: 'Выберите сумму перевода',
                predictAmount: 'Будет обменяно',
                qamount: 'Сумма',
                qrate: 'Курс',
                qexamount: 'Сумма обмена',
                withdrawcodein: 'Пополнение кодом вывода',
                withdrawcodeout: 'Вывод кодом вывода',
                contractfee: 'Комиссия контракта',
                contractprofit: 'Прибыль контракта',
                contractloss: 'Убыток контракта',
                optionfail: 'Опцион неудачен',
                optionfee: 'Комиссия опциона',
                optionreward: 'Награда опциона',
                other: 'Другое'
            },
            recharge: {
                recharge: 'Депозит',
                symbol: 'Монета',
                address: 'Адрес депозита',
                copy: 'Копировать',
                qrcode: 'QR-код',
                qrcodeaddress: 'QR-код для пополнения',
                msg1: 'Не пополняйте на указанный адрес активы другой валюты, иначе активы не будут восстановлены.',
                msg2: 'После пополнения на указанный адрес требуется подтверждение всей сети: после 2 сетевых подтверждений средства поступают, после 6 подтверждений их можно вывести.',
                msg3: 'Минимальная сумма пополнения: ',
                msgtop: 'Этот адрес предназначен только для пополнения ',
                msg3_1: ', пополнение меньше минимальной суммы не будет зачислено.',
                msg4: 'Ваш адрес пополнения не будет часто меняться, его можно использовать повторно. При изменении мы постараемся уведомить вас через объявление на сайте или эл. почту.',
                msg5: 'Обязательно проверьте безопасность компьютера и браузера, чтобы предотвратить подмену или утечку информации.',
                record: 'Запись',
                copysuccess: 'Успешно!',
                copyerr: 'Ошибка! Скопируйте вручную',
                time: 'Время поступления',
                amount: 'Количество',
                gettingaddress: 'Получение адреса депозита, подождите...',
                getaddress: 'Получить адрес депозита',
                memotips: 'При пополнении укажите этот Memo, иначе вы потеряете активы.',
                withdrawrecharge: 'Пополнение по коду',
                coderechargetip: 'Введите код вывода',
                rechargesuccess: 'Поздравляем, пополнение успешно!',
                rechargeconfirm: 'Подтверждение пополнения',
                status: 'Статус'
            },
            withdraw: {
                pickup: 'Вывод',
                addressmanager: 'Управление адресами',
                withdrawbycode: 'Вывод по коду',
                withdrawcode: 'Код вывода',
                symbol: 'Монета',
                address: 'Адрес',
                num: 'Количество',
                avabalance: 'Доступный баланс',
                msg1: 'Количество монет ниже',
                msg2: 'Автоматически поступает на аккаунт, иначе требуется ручная проверка',
                increase: 'Увеличить кредит',
                tip1: 'Введите до ',
                tip11: 'десятичных знаков, минимальное значение',
                tip2: 'Максимальное значение',
                numtip1: 'Введите количество монет',
                fee: 'Комиссии',
                range: 'Диапазон',
                arriamount: 'Количество поступления',
                msg3: 'Минимальное количество монет',
                msg4: 'валюта',
                msg5: 'Для безопасности средств, когда меняется политика безопасности аккаунта, пароль или используется новый адрес вывода, мы проводим ручную проверку вывода. Пожалуйста, дождитесь звонка или письма от сотрудника.',
                msg6: 'Обязательно проверьте безопасность компьютера и браузера, чтобы предотвратить подмену или утечку информации.',
                record: 'Запись выводов',
                symboltip: 'Выберите валюту',
                addresstip: 'Заполните адрес',
                numtip2: 'Введите корректное количество монет, минимальное значение',
                numtip3: 'Сумма монет не должна быть меньше комиссии обработки',
                amounttip: 'Введите сумму',
                feetip1: 'Минимальная комиссия',
                feetip2: 'Максимальное значение',
                time: 'Время вывода',
                status: 'Статус',
                status_1: 'На проверке',
                status_2: 'Переводится',
                status_3: 'Ошибка',
                status_4: 'Успешно',
                St5: 'Оценочная цена принудительного закрытия',
                St6: 'Общие активы = баланс кошелька + нереализованное',
                St7: 'Нереализованная прибыль/убыток = нереализованная Прибыль/убыток, рассчитанная по последней цене всех удерживаемых контрактов',
                St8: 'Баланс кошелька = переводы вход - переводы выход - реализованная прибыль и убыток',
                St9: 'Отклонено',
                remark: 'Примечание',
                add: 'Добавить',
                addresslist: 'Список адресов',
                safevalidate: 'Проверка безопасности',
                telno: 'Телефон',
                mtelno: 'Аутентификация мобильного телефона',
                memail: 'Аутентификация почты',
                smscode: 'Код проверки телефона',
                second: 'секунда',
                clickget: 'Получить',
                email: 'Эл. почта',
                emailcode: 'Код проверки эл. почты',
                save: 'Сохранить',
                delete: 'Удалить',
                telerr: 'Неверный номер телефона',
                emailerr: 'Неверная эл. почта',
                codeerr: 'Неверный код проверки',
                remarktip: 'Введите примечание',
                savemsg1: 'Сохранение не удалось!',
                savemsg2: 'Успешно сохранено!',
                operate: 'Действие',
                fundpwdtip: 'Введите пароль средств',
                click: 'нажмите',
                filtrate: 'можно фильтровать',
                txid: "TxId",
                generateCode: 'Сгенерировать код вывода',
                withdrawcodelist: 'Список кодов вывода',
                withdrawcodestatus: 'Статус',
                submit: 'Отправить',
                generatecodesuccess: 'Код вывода сгенерирован!',
                wi1: 'Сеть',
                wi2: 'Аутентификация безопасности',
                wi3: 'Полученная сумма',
                wi4: 'Адрес получения',
                wi5: 'Сеть вывода',
                wi6: 'Общая сумма вывода',
                wi7: 'Сетевая комиссия',
                wi8: 'Убедитесь, что вы ввели правильный адрес вывода и выбранная сеть вывода соответствует адресу',
                wi9: 'Ордера вывода нельзя отменить после создания',
                wi10: 'Продолжить',
                wi11: 'Пароль средств',
                wi12: 'код проверки телефона',
                wi13: 'Отправить',
                wi14: 'Код',
                wi15: 'Отправить',
                wi16: 'Отправить',
            }
        },
        member: {
            usercenter: 'Профиль пользователя',
            securitycenter: 'Центр безопасности',
            securitysetting: 'Настройки безопасности',
            accountsetting: 'Настройки аккаунта',
            account: 'Аккаунт',
            assets: 'Финансы',
            exchange: 'Обмен',
            curdelegate: 'Текущие заявки',
            hisdelegate: 'История заявок',
            otc: "OTC"
        },
        order: {
            ordercenter: 'Центр ордеров',
            myorder: 'Мой ордер',
            myad: 'Мое объявление',
        },
        regist: {
            Res1: 'Имя пользователя состоит из заглавных и строчных букв и цифр, и должно содержать буквы',
            hasaccount: 'Уже есть аккаунт? Войти',
            login: 'Войти',
            username: 'Имя пользователя',
            country: 'Страна',
            smscode: 'SMS-код проверки',
            sendcode: 'Отправить',
            resendcode: 'Отправить снова(',
            pwd: 'Пароль',
            repwd: 'Подтвердить пароль',
            confrimpwd: 'Подтвердить пароль',
            agreement: 'Я прочитал и согласен',
            userprotocol: 'Пользовательское соглашение',
            regist: 'Зарегистрироваться',
            teltip: 'Введите телефон',
            telerr: 'Ошибка формата телефона, введите снова',
            emailtip: 'Введите эл. почту',
            emailerr: 'Неверный формат эл. почты, введите снова',
            confirmpwdtip: 'Введите подтверждение пароля',
            confirmpwderr: 'Пароли не совпадают!',
            telregist: 'Регистрация по телефону',
            emailregist: 'Регистрация по эл. почте',
            usernametip: 'Введите имя пользователя',
            usernamemsg: 'Длина имени пользователя не менее 3 и не более 15',
            countrytip: 'Выберите страну',
            smscodetip: 'Введите SMS-код проверки',
            pwdtip: 'Введите пароль входа',
            pwdmsg: 'Длина пароля не менее 6',
            telno: 'Телефон',
            email: 'Эл. почта',
            agreementtip: 'Нажмите, чтобы согласиться',
            modaltitle: 'Пожалуйста, пройдите проверку',
            promotion: 'Код приглашения',
            china: 'Китай',
            singapore: 'Сингапур',
            korea: 'Корея',
            japan: 'Япония',
            thailand: 'Таиланд',
            russia: 'Россия',
            uk: 'Великобритания',
            vietnam: 'Вьетнам',
            india: 'Индия',
            italy: 'Италия',
            hk: 'Гонконг',
            malaysia: 'Малайзия',
            taiwan: 'Тайвань',
            turkey: 'Турция',
            germany: 'Германия',
            france: 'Франция',
            spain: 'Испания',
            us: 'США',
        },
        safe: {
            beneficiaryTitle: 'Информация о бенефициаре',
            beneficiaryEmpty: 'Информация о бенефициаре не задана',
            beneficiaryName: 'Имя бенефициара',
            beneficiaryIdNumber: 'Номер удостоверения бенефициара',
            beneficiaryMobilePhone: 'Мобильный телефон бенефициара',
            beneficiaryNamePlaceholder: 'Введите имя бенефициара',
            beneficiaryIdPlaceholder: 'Введите номер удостоверения бенефициара',
            beneficiaryMobilePlaceholder: 'Введите мобильный телефон бенефициара',
            beneficiaryTip: 'Используется для регистрации и обновления имени бенефициара, номера удостоверения и мобильного телефона.',
            beneficiaryNameRequired: 'Введите имя бенефициара',
            beneficiaryNameInvalid: 'Имя бенефициара должно содержать 2-30 символов',
            beneficiaryIdRequired: 'Введите номер удостоверения бенефициара',
            beneficiaryIdInvalid: 'Неверный формат номера удостоверения бенефициара',
            beneficiaryMobileRequired: 'Введите мобильный телефон бенефициара',
            beneficiaryMobileInvalid: 'Неверный формат мобильного телефона бенефициара',
            Ad1: 'Загрузите карту соцстрахования, водительское удостоверение или паспорт',
            Ad2: 'Перед отправкой загрузите один из файлов',
            Ad3: 'Полное имя',
            Ad4: 'Контактный адрес',
            Ad5: 'Прямая трансляция',
            Ad6: 'Мои трансляции',
            Ad7: 'Добавление не удалось, максимум можно добавить 3',
            size: 'Размер загружаемого изображения не должен превышать 5M',
            safelevel_low: 'Уровень безопасности: низкий',
            safelevel_high: 'Уровень безопасности: высокий',
            safelevel_medium: 'Уровень безопасности: средний',
            nickname: 'Никнейм',
            bind: 'Привязать',
            binded: 'Привязано',
            verifypass: 'Проверено',
            binding: 'Привязка',
            binderr: 'Ошибка',
            bindretry: 'Повторить',
            verified: 'Проверено',
            notverified: 'Не проверено',
            verifiedtip: 'Для защиты аккаунта пройдите проверку реального имени перед торговыми операциями!',
            realname: 'Реальное имя',
            idcard: 'ID-карта',
            upload: 'Загрузить',
            upload_positive: 'Загрузить лицевую сторону ID',
            upload_negative: 'Загрузить обратную сторону ID',
            upload_hand: 'Загрузить фото с ID в руках',
            save: 'Сохранить',
            reset: 'Сброс',
            email: 'Эл. почта',
            bindemail: 'Привязать эл. почту',
            loginpwd: 'Пароль входа',
            emailcode: 'Код проверки эл. почты',
            clickget: 'Нажмите для получения',
            second: 's',
            phone: 'Телефон',
            bindphone: 'Привязать телефон',
            phonecode: 'Код проверки телефона',
            logintip: 'Используется при входе на платформу',
            edit: 'Изменить',
            oldpwd: 'Старый пароль входа',
            newpwd: 'Новый пароль входа',
            confirmnewpwd: 'Подтвердить новый пароль',
            fundpwd: 'Пароль средств',
            fundtip: 'При изменении средств аккаунта сначала требуется подтвердить пароль средств',
            set: 'Настроить',
            confirmpwd: 'подтвердить пароль',
            oldfundpwd: 'Старый пароль средств',
            newfundpwd: 'Новый пароль средств',
            newpwdmsg1: 'Введите новый пароль входа не менее 6 символов',
            newpwdmsg2: 'Новый пароль входа не совпадает',
            pwdmsg1: 'Введите пароль не менее 6 символов',
            pwdmsg2: 'Пароль не совпадает',
            emailtip: 'Введите эл. почту',
            codetip: 'Введите код проверки',
            telnotip: 'Введите номер телефона',
            oldpwdtip: 'Введите исходный пароль',
            realnametip: 'Введите ваше реальное имя',
            idcardtip: 'Введите номер ID',
            bindphonetip: 'Сначала привяжите телефон!',
            resetfundpwd: 'Сбросить пароль средств',
            upload_positivetip: 'Загрузите лицевую сторону ID-карты',
            upload_negativetip: 'Загрузите обратную сторону ID-карты',
            upload_handtip: 'Загрузите фото с ID в руках',
            save_success: 'Успешно!',
            save_failure: 'Ошибка!',
            imgtip: 'Загрузите QR-код для получения средств',
            idcard_verifymsg1: "1. Файл должен быть меньше 8 МБ. Информация на документе должна быть четко видна; изменения документа или закрытие посторонними предметами не допускаются, номер и имя документа должны быть видимы.",
            idcard_verifymsg2: "2. На фотографии вы должны быть без головного убора. Рекомендуется без макияжа. Черты лица человека, держащего документ, должны быть четкими, руки должны быть полностью видны.",
            idcard_verifymsg3: "3. Необходимо держать документ и рукописную записку (имя + дата заявки): 'Все мои действия на этом сайте выполняются мной лично, я понимаю связанные риски и готов нести все юридические последствия по этому аккаунту.'"
        },
        account: {
            pagetitle: 'Привязать аккаунт с реальным именем',
            pagetip: 'Настройте способ оплаты и используйте аккаунт, оформленный на ваше реальное имя',
            backcardno: 'Банковский счет',
            backcardtip: 'Информация о личной банковской карте не привязана',
            modify: 'Изменить',
            bind: 'Привязать',
            name: 'Имя',
            bankaccount: 'Банковский счет',
            bankbranch: 'Отделение банка',
            bankno: 'Номер банковской карты',
            confirmbankno: 'Подтвердите номер карты',
            fundpwd: 'Пароль средств',
            save: 'Сохранить',
            zfbaccount: 'Аккаунт Alipay',
            zfbaccounttip: 'Личный аккаунт Alipay не привязан',
            wxaccount: 'Аккаунт WeChat',
            wxaccounttip: 'Личный аккаунт WeChat не привязан',
            banknomsg1: 'Введите корректный номер банковской карты',
            banknomsg2: 'Введенные номера банковской карты не совпадают!',
            verifiedmsg: 'Сначала пройдите проверку реального имени',
            bankaccountmsg: 'Выберите ваш банк',
            bankbranchmsg: 'Введите отделение счета',
            banknomsg: 'Введите корректный номер банковской карты',
            fundpwdmsg1: 'Введите корректный финансовый пароль',
            fundpwdmsg2: 'Пароль не может быть короче 6 символов',
            zfbaccountmsg: 'Введите аккаунт Alipay',
            wxaccountmsg: 'Введите аккаунт WeChat',
            save_success: 'Успешно!',
            save_failure: 'Ошибка!',
        },
        otcorder: {
            unpaid: 'Не оплачено',
            paided: 'Оплачено',
            finished: 'Завершено',
            canceled: 'Отменено',
            appealing: 'В апелляции',
            searchtip: 'Введите номер ордера',
            orderno: 'Номер ордера',
            created: 'Время',
            symbol: 'Монета',
            type: 'Тип',
            type_sell: 'продать',
            type_buy: 'купить',
            tradename: 'Название сделки',
            amount: 'Количество',
            money: 'Сумма',
            fee: 'Комиссия',
        },
        identity: {
            certified: "уже сертифицировано",
            placeholder: "Укажите причину отмены",
            apply: 'Подать заявку на статус мерчанта',
            become: "Станьте сертифицированным мерчантом BIPPAX и получите больше торговых привилегий",
            zhusnhu: "Мерчанты получают эксклюзивные рекламные места для повышения успешности сделок",
            tijiaoziliao: "Отправить данные для проверки мерчанта",
            place: "Загрузите подготовленные данные проверки мерчанта на платформу и отправьте заявку",
            tijiao: "Ваша заявка на сертификацию мерчанта отправлена",
            tijiaosuc: "Поздравляем, ваша сертификация мерчанта пройдена",
            tijiaofail: "К сожалению, сертификация мерчанта не пройдена",
            zhuxiaotijiao: "Ваша заявка на отмену статуса мерчанта отправлена",
            shenhefail: "Ваша заявка на отмену статуса мерчанта не одобрена",
            shenhesuc: "Ваша заявка на отмену статуса мерчанта одобрена",
            shangjiazhuxiao: "Отмена статуса мерчанта",
            shenagain: "Проверка",
            shenheshibai: "Проверка не пройдена",
            sheqinggain: "Подать заявку",
            reason: "Причина",
            shenqingtuibao: "Подать заявку на займ",
            getquan: "У вас есть следующие разрешения",
            read: "Я прочитал и согласен",
            lijishenqing: 'Подать заявку сейчас',
            tips: "Подсказка",
            wufachexiao: "Вы выполняете отмену статуса мерчанта. После подтверждения и отправки заявки действие нельзя будет отозвать.",
            suredo: "Вы уверены, что хотите продолжить?",
            shuzizichan: "Сертификат торговли цифровыми активами",
            gerenzichan: "Сертификат личных цифровых активов",
            second: {
                line: "Как подать заявку на статус мерчанта?",
                step1: "Шаг 1: подготовьте необходимые материалы заявки мерчанта",
                step1c1: "Подготовьте следующие материалы:",
                step1c2: "Номер мобильного телефона, WeChat ID, номер QQ, сертификат личных цифровых активов (изображение), сертификат сделки с цифровыми активами (изображение)",
                step2: "Шаг 2: отправьте заявку",
                step2c: "Заполните и загрузите материалы для проверки сертификации мерчанта, затем нажмите отправить на проверку.",
                step3: "Шаг 3: проверка данных",
                stepc: "Мы рассмотрим вашу заявку в течение 3-5 дней. Следите за результатом проверки. После одобрения вы сможете публиковать объявления в зоне фиатного обмена.",
                agree: "Согласен заморозить",
                agreec: "В качестве депозита мерчанта",
                shenqingchngweishangjia: "Подать заявку на статус мерчанта",
            },
            yuanyin: "Причина",
            bizhong: "Валюта депозита",
            shuliang: "Сумма маржи",
            chosen: "Выберите валюту",
            seat: 'Эксклюзивное место',
            service: 'Индивидуальное обслуживание',
            lowfee: 'Более низкие комиссии',
            phone: 'Телефон',
            balance: 'Личные активы',
            cardphoto: 'Фото лицевой и обратной стороны удостоверения',
            wx: 'WeChat',
            exchange: 'Участвуете ли вы во внебиржевой торговле цифровыми активами',
            handphoto: 'Фото пользователя с удостоверением в руках',
            qq: 'QQ',
            ploy: 'Есть ли соответствующая стратегия контроля рисков',
            agreement: '《Соглашение сертифицированного мерчанта》',
            applyfor: 'Подать заявку',
            sendcode: 'Отправить',
            confirm: 'Подтвердить',
            prepare: 'Подготовить материалы',
            result: "Ожидать результат",
            review: 'Отправить на проверку',
            passed: 'Проверка пройдена',
            approve: 'Согласитесь с соглашением сертифицированного мерчанта',
            emailtip1: 'Отправьте следующие материалы на эл. почту',
            emailtip2: 'Мы рассмотрим вашу заявку как можно скорее.',
        },
        extension: {
            title1: 'Промо-ссылки',
            title2: 'Приглашенные друзья',
            title3: 'Моя комиссия',
            linkdesc: 'Следующий URL является вашим адресом для внешнего продвижения. Вы можете распространять его среди друзей, в QQ, WeChat, Weibo, блогах, форумах или на своем сайте. Все пользователи, зарегистрировавшиеся по этому адресу, станут вашими приглашенными пользователями. Когда они совершают операции на сайте, вы можете получать комиссию; подробности продвижения доступны в истории доступа.',
            linktitle: 'Ваши промо-ссылки',
            copy: 'Копировать',
            copy_msg1: 'Успешно скопировано!',
            copy_msg2: 'Ошибка! Скопируйте вручную',
            username: 'Имя',
            currrecharge: 'Сделка',
            userlevel: 'Уровень пользователя',
            createdtime: 'Время регистрации',
            currcommission: 'Текущая комиссия',
            managerfee: 'Комиссия за управление',
            yuan: 'юань (RMB)',
            symbol: 'COIN',
            amount: 'Количество',
            remark: 'Примечание',
            amounttime: 'Время доставки',
        },
        promotion: {
            title: "Центр продвижения",
            subtitle1: "Мои карты",
            subtitle2: "История обмена",
            subtitle3: "Мое продвижение",
            card_column0: "Код обмена",
            card_column1: "Имя",
            card_column2: "Символ монеты",
            card_column3: 'Количество',
            card_column4: "Крайний срок",
            card_column5: "Всего",
            card_column6: "Обменено",
            card_column7: 'Время создания',
            my_column0: "Пригласить пользователя",
            my_column1: "Дата регистрации",
            my_column2: "Реальное имя",
            gopromotion: 'Продвижение',
            inputcardno: "Введите код карты",
            exchange: 'Обмен',
            exchangesuccess: "Поздравляем! Вы можете проверить активы в финансовом центре!",
            exchangewithcode: "Обменять по коду"
        },
        activity: {
            navTitle: "Инновации ",
            subNavTitle1: "Мои ордера",
            subNavTitle2: "Моя добыча",
            subNavTitle3: "Мои блокировки",
            column1: "Имя",
            column2: 'Тип',
            column3: 'Количество',
            column4: "Единица (вход)",
            column5: "Единица (выход)",
            column6: 'Статус',
            column7: 'Оборот',
            column8: 'Время создания',
            mColumn1: "Изображение",
            mColumn2: "Имя",
            mColumn3: "Единица монеты",
            mColumn4: "Период",
            mColumn5: "Дни добычи",
            mColumn6: "Дней добыто",
            mColumn7: 'Статус',
            mColumn8: "Базовая мощность",
            mColumn9: "Текущая мощность",
            mColumn10: "Всего добыто",
            mColumn11: 'Дата окончания',
            mColumn12: "Дата создания",
            lColumn1: "Изображение",
            lColumn2: "Имя",
            lColumn3: "Единица монеты",
            lColumn4: "Период",
            lColumn5: "Дни блокировки",
            lColumn6: "Дни выпуска",
            lColumn7: 'Статус',
            lColumn8: "Базовая мощность",
            lColumn9: "Текущая мощность",
            lColumn10: "Всего выпущено",
            lColumn11: 'Дата окончания',
            lColumn12: "Дата создания",
        },
        mining: {
            title: "Список моей добычи",
            empty: "Нет записей",
            day: "День",
            week: "Неделя",
            month: "Месяц",
            year: "Год",
            invitetip1: "Мощность майнинг-машины можно увеличить, приглашая друзей. Каждый приглашенный пользователь, обменявший майнинг-машину, увеличит мощность ",
            invitetip2: "Верхний предел увеличения мощности ",
            miningUnit: "Единица добычи",
            miningPeriod: "Период добычи",
            miningDays: "Количество добычи",
            miningedDays: "Добыто раз",
            miningDaysProfit: "Базовый выпуск",
            miningCurrentDaysProfit: "Текущий выпуск",
            status0: "Ожидает развертывания",
            status1: "Развернуто",
            status2: "Завершено"
        },
        locked: {
            title: "Список моих блокировок",
            empty: "Нет записей",
            day: "День",
            week: "Неделя",
            month: "Месяц",
            year: "Год",
            invitetip1: "Мощность блокировки можно увеличить, приглашая друзей. Каждый приглашенный пользователь, обменявший блокировку, увеличит мощность ",
            invitetip2: "Верхний предел увеличения мощности ",
            miningUnit: "Единица выпуска",
            miningPeriod: "Период выпуска",
            miningDays: 'Число выпусков',
            miningedDays: "Выпущено раз",
            miningDaysProfit: "Базовый выпуск",
            miningCurrentDaysProfit: "Текущий выпуск",
            status0: "Ожидает выпуска",
            status1: "Выпускается",
            status2: "Завершено",
            totallocked: "Всего заблокировано"
        },
        api: {
            apiAdmin: "Управление API",
            createApi: "Создать новый ключ API",
            mark: "Примечание",
            bindAddress: "Ключ без привязанного IP-адреса действителен 90 дней",
            hint: 'Подсказка',
            part1: "Мы предоставляем мощный API, с помощью которого можно использовать запросы рынка, автоматические сделки и другие сервисы",
            apiDoc: "через документацию API.",
            howUse: "Подробнее об использовании см.",
            // part2: "Каждый пользователь может создать до пяти наборов API-ключей",
            part2: "Каждый пользователь может создать до 5 наборов ключей API",
            part3: "Не раскрывайте ваш ключ API, чтобы избежать потери активов. В целях безопасности рекомендуется привязать IP к ключу API; для каждого ключа API можно привязать максимум 5 IP. Один адрес вводится напрямую, несколько IP-адресов разделяются запятыми, например: 192.168.1.1, 192.168.1.2, 192.168.1.3.",
            myApiKey: "Мой ключ API",
            ipAddress: "IP-адрес",
            // createTime: "Время создания",
            createTime: "Время создания",
            accessKey: "Ключ доступа",
            bindIpAddress: "Привязать IP-адрес",
            // ioDays: "Оставшийся срок действия (дней)",
            ioDays: "Оставшиеся дни",
            operation: "Операция",
            create: "Создать",
            edit: 'редактировать',
            delete: 'удалить',
            sureDelete: "Вы уверены, что хотите удалить?",
            tips: "Ключ отображается только при добавлении, сохраните его вовремя.",
            copy: "Копировать",
            access: "Ключ",
            okText: "Подтвердить",
            cancel: "Отмена"
        }
    },
    cms: {
        noticecenter: 'Центр объявлений',
        newshelp: 'Помощь новым пользователям',
        appdownload: 'Скачать приложение',
        onlineservice: 'Онлайн-сервис',
        faq: 'Частые вопросы',
        notice: 'Объявление',
        servicecenter: 'Центр поддержки',
        about: 'О нас',
        joinus: 'Присоединяйтесь к нам',
        aboutus: 'О нас',
        exchangerule: 'Правила торговли',
        useprotocol: 'Пользовательское соглашение',
        feenote: 'Описание комиссий',
        merchantprocotol: 'Соглашение мерчанта',
        features: "Особенности",
        contactus: "Связаться с нами",
        noticelist: 'Все объявления',
        nextnotice: 'Следующее',
        prevnotice: "Предыдущее",
        notexist: "Посещенная страница не существует или была удалена",
        otherhelp: "Другое в этой категории",
        scanforshare: "Сканируйте, чтобы поделиться",
        download: "Скачать",
        downloadslogan: "BIPPAX APP - торгуйте везде."
    },
    description: {
        title1: 'Безопасность',
        title2: 'Сервис 24/7',
        title3: 'Глобальная биржа',
        title4: 'Строгий отбор проектов',
        message1: 'Комплексная система финансового контроля рисков и защиты от краж, горячие и холодные кошельки, мультиподпись для обеспечения безопасности средств',
        message2: 'Круглосуточная ручная онлайн-проверка помогает клиентам не упустить лучшие инвестиционные возможности.',
        message3: 'Глобальная сеть бизнес-сервисов помогает инвестировать в криптоактивы по всему миру и совершать сделки с глобальными пользователями',
        message4: 'Мы строго отбираем качественные блокчейн-проекты и отсеиваем для вас 80% проектов с крайне высоким риском.',
        scanqrcode: "Скачать приложение",
        aboutdesc1: "BIPPAX.PRO - ведущая мировая платформа торговли цифровыми активами, зарегистрированная на Каймановых островах, с основной операционной командой в Гонконге. Ключевые участники BIPPAX.PRO пришли из ведущих интернет- и финансовых компаний. Большинство из них глубоко верят в Bitcoin и блокчейн. Мы уверены, что блокчейн изменит традиционную монопольную финансовую систему и создаст более демократичную и автономную социальную структуру.",
        aboutdesc2: "Платформа BIPPAX.PRO использует профессиональную торговую архитектуру финансового уровня и собственный высокопроизводительный движок сопоставления ордеров в памяти. Платформа применяет систему холодных кошельков, мультиподпись, высокозащищенную систему против DDoS-атак и другие решения для обеспечения безопасности активов клиентов.",
        aboutdesc3: "Чтобы клиенты лучше использовали инвестиционные возможности, BIPPAX.PRO применяет плоскую структуру управления в службе поддержки и создает сверхбыстрый механизм реагирования. Менеджеры поддержки активов находятся онлайн 24/7 круглый год, предоставляя услуги пополнения и вывода активов и помогая клиентам завершать пополнение в течение 25 минут.",
        aboutdesc4: "BIPPAX.PRO строго отбирает качественные проекты и предоставляет безопасные и стабильные услуги хранения активов. BIPPAX.PRO придерживается принципов честности, справедливости, энтузиазма и открытости, стремясь создать для пользователей безопасную, надежную, эффективную и дружелюбную биржу.",
        aboutdesc5: "Хотя цифровые активы пока распространены в узком кругу, мы верим, что этот тип активов, которым каждый может полностью владеть, станет популярным в будущем. Давайте работать вместе и смотреть вперед!",
        support: "Поддержка",
        report: "Предложение",
        service: "Служба поддержки",
        apply: "Заявка на листинг",
        coop: "Сотрудничество",
        community: "Сообщество BIPPAX",
        wechat: 'WeChat',
        addwechat: "Добавьте 'coinex' в друзья WeChat, затем войдите в сообщество WeChat",
        weibo: "Weibo",
        twitter: "Twitter",
        biyong: "Biyong",
        telegram: "Telegram",
        medium: "Medium",
        reddit: "Reddit"
    },
    bzb_description: {
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        title5: "",
        title6: "",
        title7: "",
        title8: "",
        desc1: "",
        desc2: "",
        desc3: "",
        desc4: "",
        desc5: "",
        desc6: "",
        desc7: "",
        desc8: ""
    },
    footer: {
        wechatkefu: "Сервис WeChat",
        notice: 'Объявление',
        gsmc: 'Биржа лучших криптовалют',
        bah: 'No. 13026899 -3, Shanghai ICP',
        gsjj: 'Профиль',
        gywm: 'О нас',
        jrwm: 'Присоединяйтесь к нам',
        biyong: 'BiYong',
        lxwm: 'Связаться с нами',
        yqlj: 'Ссылки',
        bzzx: 'Помощь',
        xsrm: " Курс для начинающих",
        czzn: 'Руководство по пополнению',
        jyzn: 'Руководство по торговле',
        ptsm: 'Пояснение',
        fysm: 'Комиссии',
        fwtk: 'Политика сервиса',
        fltk: 'Правовая политика',
        wechat: "Поддержка WeChat",
        xszn: "Руководство для начинающих",
        cjwt: "Частые вопросы",
        mztk: "Отказ от ответственности",
        ystk: "Политика конфиденциальности",
        tkxy: "Условия",
        gybzb: "О нас BZB",
        kfyx: "Эл. почта поддержки",
        swhz: "Сотрудничество",
        sbsq: "Заявка на листинг",
        jyzn: "Руководство по обмену",
        bzzl: "Информация о монете",
        tsjb: "Отчет",
        apidoc: "Документация API",
        zwkf: "Скоро будет"
    },
    index: {
        circulation: 'Обращение фонда безопасности и развития',
        hourEth: 'Накопленный доход к распределению сегодня',
        yesterdayEth: 'Накопленный доход к распределению вчера',
        yesterday: 'Объем добычи за предыдущий день:',
        bhbTotal: "Общий выпуск BHB",
        bhbSecond: "Обращение BHB на вторичном рынке",
        checkMineprinciple: "Посмотреть принцип майнинга",
        checkFlowVolum: 'Проверка обращения',
        checkLockPosition: 'Проверить состояние блокировки',
        BHBregister: "Регистрация аккаунта BIPPAX",
        tibi: "Время и лимит оплаты по счету",
        line_plane: "Объявление о плане запуска BHB, обращении и возврате сервисных комиссий",
        fenpeijizhi: 'Описание механизма распределения доходов BIPPAX',
        jiangli_jihua: "Схема наград за приглашения в майнинге",
        friend_fanhuan: "Приглашайте друзей, зарабатывайте дополнительную комиссию и возврат"
    },
    plate: {
        title: "Схема распределения доходов платформы (права держателей BHB)",
        content1: "Как описано в Белая книга, BIPPAX направляет 80% доходов платформы (после вычета налогов и сборов) держателям BHB, а 20% доходов используется для поддержки НИОКР и операционной деятельности платформы.",
        content2: "Распределение доходов выполняется по дневному циклу, первым днем распределения является 6 июня 2018 года. Каждый последующий день общий доход, подлежащий распределению за предыдущий день, распределяется между держателями BHB пропорционально.",
        content3: "（Примечание: 1. Здесь BHB означает только выпущенный / обращающийся BHB. См. также【",
        content3_1: 'Примечание о соотношении обращения BHB / участия в распределении дохода',
        content3_2: "2. Почасовой снимок (в начале часа) рассчитывается один раз, а распределение дохода выполняется один раз в день.",
        hourFenpei: "Распределение дохода сегодня",
        hourTotal: "Общий доход платформы сегодня",
        xiangqing: "Детали сегодняшнего распределения дохода",
        yesterdaytit: "Распределение дохода вчера",
        yesterdaytotal: "Общий доход платформы вчера",
        yesterdayxiangqing: "Детали вчерашнего распределения дохода",
        yesterday: {
            total: "Общий доход",
            allocated: "Нераспределенный доход",
        }
    },
    feereturn: {
        ruletitle: 'Примечание',
        rulecontent: 'В нашем Белая книга подробно объясняется возврат торговых комиссий. В целом 51% общей базы BHB платформы' + ' (далее "доля вознаграждения сообщества") будет постепенно возвращаться пользователям через механизм "Trans-Fee Mining". Когда эти 51% общего объема BHB будут полностью выпущены через возврат, механизм "Trans-Fee Mining" автоматически завершится. ',
        recordtitle: 'Список',
        recordcontent: 'Каждый день (UTC+8, далее аналогично) BHB будет возвращать 100% торговых комиссий пользователей' + 'за предыдущий день в форме BHB. Расчет выполняется по средней цене BHB предыдущего дня (средняя цена = общий объем стоимости сделок / общий объем сделок). Возврат комиссий за предыдущий день в форме BHB завершается ежедневно в 11:00.',
        time: "Дата",
        todaycharge: "Средняя цена (ETH)",
        totalChange: 'Всего (ETH)',
        returnCharge: "Возврат Trans-Fee Mining (BHB)",
        todayChargeReturn: "Программа стимулирования возврата FCoin (BHB)"
    },
    home: {
        login: {
            title: 'Начните торговать криптовалютами',
            desc: 'Поддержка 500+ криптовалют и различных торговых инструментов',
            btnText: 'Торговать сейчас'
        },
        unlogin: {
            title: 'Начните путь с цифровыми активами',
            desc: 'Зарегистрируйтесь и получите подарок для нового пользователя',
            placinfo: 'Телефон / эл. почта',
            btnText: 'Регистрация'
        },
        WelfareCenter: 'Центр бонусов',
        Welcome_ceremony: 'Подарок новому пользователю',
        Airdrop: 'Эйрдроп',
        DailyGain: 'Ежедневные награды',
        AirdropGift: 'Подарки эйрдропа',
        financial_management: 'Оптимизированное управление финансами',
        Zhoude: 'Еженедельные награды',
        height_is: 'до',
        Happiness: 'Карнавал удачи',
        Monthly: 'Ежемесячные награды',
        CarveUp: 'Призовой фонд',
        download: {
            transactions_anytime: 'Торгуйте в любое время и в любом месте',
            scan_code: 'Сканируйте для скачивания',
            download_more: 'Скачать еще'
        },
        brand: {
            digital_platform: 'Ведущая платформа торговли цифровыми активами',
            rich_digital: 'Широкие сервисы торговли цифровыми активами и управления активами для разных торговых потребностей',
            High_quality_digital: 'Качественные цифровые активы',
            Turnover: 'Оборот',
            safety_risk: 'Система безопасности и управления рисками мирового уровня',
            multi_factor: 'Офлайн-хранение, многофакторное шифрование, круглосуточный мониторинг платформы и комплексная защита активов пользователей',
            Security_reserve: 'Резервный фонд безопасности',
            accident: '0 инцидентов за 9 лет',
            safetyrisk: 'Безопасность и контроль рисков высшего уровня',
            choice_trusted: 'Выбор, которому доверяют миллионы пользователей',
            transaction_service: 'Локализованные торговые сервисные центры созданы во многих странах и регионах мира, формируя блокчейн-экосистему с разными направлениями бизнеса',
            ten_thousand: '10,000',
            User_preference: 'Предпочтение пользователей',
            Countries_covered: 'Охваченные страны'
        },
        trading: {
            digital_currency: 'Начните путь с цифровыми активами',
            register: 'Регистрация',
            login: 'Войти',
            currency_transaction: 'Начните торговать криптовалютами',
            to_trade: 'Торговать сейчас'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/ru/index.js